// ============= Country & Cities Store (localStorage) =============

export interface Area {
  id: string;
  nameAr: string;
  nameEn: string;
}

export interface City {
  id: string;
  nameAr: string;
  nameEn: string;
  deliveryFee?: number;
  areas?: Area[];
}

export interface Country {
  id: string;
  nameAr: string;
  nameEn: string;
  cities: City[];
  enabled: boolean;
}

const COUNTRIES_KEY = 'countries_data';
const COUNTRIES_VERSION_KEY = 'countries_version';
const COUNTRIES_VERSION = '18';

const generateId = () => crypto.randomUUID();

const defaultCountries: Country[] = [
  {
    id: 'country-jo',
    nameAr: 'الاردن',
    nameEn: 'Jordan',
    enabled: true,
    cities: [
      {
        id: 'jo-1', nameAr: 'عمان', nameEn: 'Amman',
        areas: [
          { id: 'a-1', nameAr: 'وسط البلد', nameEn: 'Downtown' },
          { id: 'a-2', nameAr: 'جبل عمان', nameEn: 'Jabal Amman' },
          { id: 'a-3', nameAr: 'جبل الحسين', nameEn: 'Jabal Al-Hussein' },
          { id: 'a-4', nameAr: 'جبل اللويبدة', nameEn: 'Jabal Al-Lweibdeh' },
          { id: 'a-5', nameAr: 'جبل النزهة', nameEn: 'Jabal Al-Nuzha' },
          { id: 'a-6', nameAr: 'جبل النصر', nameEn: 'Jabal Al-Nasr' },
          { id: 'a-7', nameAr: 'جبل التاج', nameEn: 'Jabal Al-Taj' },
          { id: 'a-8', nameAr: 'جبل الجوفة', nameEn: 'Jabal Al-Jofeh' },
          { id: 'a-9', nameAr: 'جبل الاشرفية', nameEn: 'Jabal Al-Ashrafieh' },
          { id: 'a-10', nameAr: 'جبل القصور', nameEn: 'Jabal Al-Qusour' },
          { id: 'a-11', nameAr: 'عبدون', nameEn: 'Abdoun' },
          { id: 'a-12', nameAr: 'الشميساني', nameEn: 'Shmeisani' },
          { id: 'a-13', nameAr: 'تلاع العلي', nameEn: 'Tla Al-Ali' },
          { id: 'a-14', nameAr: 'خلدا', nameEn: 'Khalda' },
          { id: 'a-15', nameAr: 'الجبيهة', nameEn: 'Al-Jubeiha' },
          { id: 'a-16', nameAr: 'صويلح', nameEn: 'Sweileh' },
          { id: 'a-17', nameAr: 'ابو نصير', nameEn: 'Abu Nseir' },
          { id: 'a-18', nameAr: 'شفا بدران', nameEn: 'Shafa Badran' },
          { id: 'a-19', nameAr: 'طبربور', nameEn: 'Tabarbour' },
          { id: 'a-20', nameAr: 'ماركا الشمالية', nameEn: 'North Marka' },
          { id: 'a-21', nameAr: 'ماركا الجنوبية', nameEn: 'South Marka' },
          { id: 'a-22', nameAr: 'القويسمة', nameEn: 'Al-Qweismeh' },
          { id: 'a-23', nameAr: 'ابو علندا', nameEn: 'Abu Alanda' },
          { id: 'a-24', nameAr: 'الهاشمي الشمالي', nameEn: 'North Hashmi' },
          { id: 'a-25', nameAr: 'الهاشمي الجنوبي', nameEn: 'South Hashmi' },
          { id: 'a-26', nameAr: 'الرابية', nameEn: 'Al-Rabiah' },
          { id: 'a-27', nameAr: 'الدوار السابع', nameEn: '7th Circle' },
          { id: 'a-28', nameAr: 'الدوار الثامن', nameEn: '8th Circle' },
          { id: 'a-29', nameAr: 'الياسمين', nameEn: 'Al-Yasmin' },
          { id: 'a-30', nameAr: 'الرونق', nameEn: 'Al-Rawnaq' },
          { id: 'a-31', nameAr: 'دير غبار', nameEn: 'Deir Ghbar' },
          { id: 'a-32', nameAr: 'ام السماق', nameEn: 'Um Al-Summaq' },
          { id: 'a-33', nameAr: 'الصويفية', nameEn: 'Al-Sweifieh' },
          { id: 'a-34', nameAr: 'الجاردنز', nameEn: 'Gardens' },
          { id: 'a-35', nameAr: 'الظهير', nameEn: 'Al-Thahir' },
          { id: 'a-36', nameAr: 'المدينة الرياضية', nameEn: 'Sport City' },
          { id: 'a-37', nameAr: 'وادي السير', nameEn: 'Wadi Al-Seer' },
          { id: 'a-38', nameAr: 'مرج الحمام', nameEn: 'Marj Al-Hamam' },
          { id: 'a-39', nameAr: 'الجندويل', nameEn: 'Al-Jandaweel' },
          { id: 'a-40', nameAr: 'ام اذينة', nameEn: 'Um Uthaina' },
          { id: 'a-41', nameAr: 'الكرسي', nameEn: 'Al-Kursi' },
          { id: 'a-42', nameAr: 'المقابلين', nameEn: 'Al-Muqabalain' },
          { id: 'a-43', nameAr: 'سحاب', nameEn: 'Sahab' },
          { id: 'a-44', nameAr: 'الجيزة', nameEn: 'Al-Jiza' },
          { id: 'a-45', nameAr: 'الموقر', nameEn: 'Al-Muwaqqar' },
          { id: 'a-46', nameAr: 'ناعور', nameEn: 'Na\'ur' },
          { id: 'a-47', nameAr: 'ام الرصاص', nameEn: 'Um Al-Rasas' },
          { id: 'a-48', nameAr: 'خريبة السوق', nameEn: 'Khreibet Al-Souq' },
          { id: 'a-49', nameAr: 'العبدلي', nameEn: 'Al-Abdali' },
          { id: 'a-50', nameAr: 'الرصيفة', nameEn: 'Al-Rusaifah' },
          { id: 'a-51', nameAr: 'الزهراء', nameEn: 'Al-Zahra' },
          { id: 'a-52', nameAr: 'بدر الجديدة', nameEn: 'Badr Al-Jadidah' },
          { id: 'a-53', nameAr: 'طارق', nameEn: 'Tariq' },
          { id: 'a-54', nameAr: 'الوحدات', nameEn: 'Al-Wehdat' },
          { id: 'a-55', nameAr: 'ضاحية الرشيد', nameEn: 'Dahyet Al-Rasheed' },
          { id: 'a-56', nameAr: 'ضاحية الامير حسن', nameEn: 'Dahyet Al-Amir Hasan' },
          { id: 'a-57', nameAr: 'ضاحية الحسين', nameEn: 'Dahyet Al-Hussein' },
          { id: 'a-58', nameAr: 'ضاحية الياسمين', nameEn: 'Dahyet Al-Yasmin' },
          { id: 'a-59', nameAr: 'البيادر', nameEn: 'Al-Bayader' },
          { id: 'a-60', nameAr: 'ياجوز', nameEn: 'Yajuz' },
          { id: 'a-61', nameAr: 'حي نزال', nameEn: 'Hay Nazzal' },
          { id: 'a-62', nameAr: 'الجبل الاخضر', nameEn: 'Al-Jabal Al-Akhdar' },
          { id: 'a-63', nameAr: 'المنارة', nameEn: 'Al-Manarah' },
          { id: 'a-64', nameAr: 'الدوار الاول', nameEn: '1st Circle' },
          { id: 'a-65', nameAr: 'الدوار الثاني', nameEn: '2nd Circle' },
          { id: 'a-66', nameAr: 'الدوار الثالث', nameEn: '3rd Circle' },
          { id: 'a-67', nameAr: 'الدوار الرابع', nameEn: '4th Circle' },
          { id: 'a-68', nameAr: 'الدوار الخامس', nameEn: '5th Circle' },
          { id: 'a-69', nameAr: 'الدوار السادس', nameEn: '6th Circle' },
          { id: 'a-70', nameAr: 'جبل الزهور', nameEn: 'Jabal Al-Zuhour' },
          { id: 'a-71', nameAr: 'الجويدة', nameEn: 'Al-Jwaydeh' },
          { id: 'a-72', nameAr: 'خربة السوق', nameEn: 'Khirbet Al-Souq' },
          { id: 'a-73', nameAr: 'الطنيب', nameEn: 'Al-Tneib' },
          { id: 'a-74', nameAr: 'المستندة', nameEn: 'Al-Mustandah' },
          { id: 'a-75', nameAr: 'عين الباشا', nameEn: 'Ain Al-Basha' },
          { id: 'a-76', nameAr: 'ام نوارة', nameEn: 'Um Nuwarah' },
          { id: 'a-77', nameAr: 'الاذاعة والتلفزيون', nameEn: 'Radio & TV Area' },
          { id: 'a-78', nameAr: 'مجمع الشمال', nameEn: 'North Terminal' },
          { id: 'a-79', nameAr: 'مجمع الجنوب', nameEn: 'South Terminal' },
          { id: 'a-80', nameAr: 'المحطة', nameEn: 'Al-Mahatta' },
          { id: 'a-81', nameAr: 'راس العين', nameEn: 'Ras Al-Ain' },
          { id: 'a-82', nameAr: 'الدوار العاشر', nameEn: '10th Circle' },
          { id: 'a-83', nameAr: 'مطار الملكة علياء', nameEn: 'Queen Alia Airport' },
          { id: 'a-84', nameAr: 'شارع الجامعة', nameEn: 'University Street' },
          { id: 'a-85', nameAr: 'شارع المدينة المنورة', nameEn: 'Medina Munawwarah St' },
          { id: 'a-86', nameAr: 'شارع مكة', nameEn: 'Mecca Street' },
          { id: 'a-87', nameAr: 'شارع الاردن', nameEn: 'Jordan Street' },
          { id: 'a-88', nameAr: 'ضاحية الامير راشد', nameEn: 'Dahyet Al-Amir Rashed' },
          { id: 'a-89', nameAr: 'ابو السوس', nameEn: 'Abu Al-Sous' },
          { id: 'a-90', nameAr: 'الرقيم', nameEn: 'Al-Raqeem' },
          { id: 'a-91', nameAr: 'ام العمد', nameEn: 'Um Al-Amad' },
          { id: 'a-92', nameAr: 'عراق الامير', nameEn: 'Iraq Al-Amir' },
          { id: 'a-93', nameAr: 'الفحيص', nameEn: 'Al-Fuhais' },
          { id: 'a-94', nameAr: 'ماحص', nameEn: 'Mahis' },
          { id: 'a-95', nameAr: 'جبل المريخ', nameEn: 'Jabal Al-Mareekh' },
          { id: 'a-96', nameAr: 'النصر', nameEn: 'Al-Nasr' },
          { id: 'a-97', nameAr: 'العالية', nameEn: 'Al-Aliyah' },
          { id: 'a-98', nameAr: 'تقاطع مرج الحمام', nameEn: 'Marj Al-Hamam Junction' },
          { id: 'a-99', nameAr: 'الحمر', nameEn: 'Al-Hummar' },
          { id: 'a-100', nameAr: 'دابوق', nameEn: 'Dabouq' },
          { id: 'a-101', nameAr: 'بدر', nameEn: 'Badr' },
          { id: 'a-102', nameAr: 'الجامعة الاردنية', nameEn: 'University of Jordan' },
          { id: 'a-103', nameAr: 'مستشفى الجامعة', nameEn: 'Jordan University Hospital' },
          { id: 'a-104', nameAr: 'سيتي مول', nameEn: 'City Mall' },
          { id: 'a-105', nameAr: 'مكة مول', nameEn: 'Mecca Mall' },
          { id: 'a-106', nameAr: 'تاج مول', nameEn: 'Taj Mall' },
          { id: 'a-107', nameAr: 'عبدون مول', nameEn: 'Abdoun Mall' },
          { id: 'a-108', nameAr: 'مجمع جبر', nameEn: 'Jabri Complex' },
          { id: 'a-109', nameAr: 'السابع', nameEn: 'Al-Sabe' },
          { id: 'a-110', nameAr: 'المنصور', nameEn: 'Al-Mansour' },
          { id: 'a-111', nameAr: 'ام قصير', nameEn: 'Um Qusair' },
          { id: 'a-112', nameAr: 'الحرية', nameEn: 'Al-Hurriyah' },
          { id: 'a-113', nameAr: 'زها', nameEn: 'Zaha' },
          { id: 'a-114', nameAr: 'الرابع', nameEn: 'Al-Rabi' },
          { id: 'a-115', nameAr: 'حي الكوم', nameEn: 'Hay Al-Koum' },
          { id: 'a-116', nameAr: 'الامير حمزة', nameEn: 'Al-Amir Hamzah' },
          { id: 'a-117', nameAr: 'ام الحيران', nameEn: 'Um Al-Hiran' },
          { id: 'a-118', nameAr: 'القسطل', nameEn: 'Al-Qastal' },
          { id: 'a-119', nameAr: 'زيزيا', nameEn: 'Zizya' },
          { id: 'a-120', nameAr: 'العدليه', nameEn: 'Al-Adliyeh' },
          { id: 'a-121', nameAr: 'المصدار', nameEn: 'Al-Misdar' },
          { id: 'a-122', nameAr: 'حي الاسكان', nameEn: 'Hay Al-Iskan' },
          { id: 'a-123', nameAr: 'خلة الوردة', nameEn: 'Khallet Al-Wardeh' },
          { id: 'a-124', nameAr: 'ضاحية المدينة المنورة', nameEn: 'Dahyet Al-Madinah' },
          { id: 'a-125', nameAr: 'حي ابو الراغب', nameEn: 'Hay Abu Al-Ragheb' },
          { id: 'a-126', nameAr: 'جبل القلعة', nameEn: 'Jabal Al-Qalaa' },
          { id: 'a-127', nameAr: 'النظيف', nameEn: 'Al-Natheef' },
          { id: 'a-128', nameAr: 'ماركا المطار', nameEn: 'Marka Airport' },
          { id: 'a-129', nameAr: 'الامير حسن', nameEn: 'Al-Amir Hasan' },
          { id: 'a-130', nameAr: 'المغيرات', nameEn: 'Al-Mughayyarat' },
          { id: 'a-131', nameAr: 'ضاحية الاقصى', nameEn: 'Dahyet Al-Aqsa' },
          { id: 'a-132', nameAr: 'الرجيب', nameEn: 'Al-Rajib' },
          { id: 'a-133', nameAr: 'مخيم البقعة', nameEn: 'Baqaa Camp' },
          { id: 'a-134', nameAr: 'البقعة', nameEn: 'Al-Baqaa' },
          { id: 'a-135', nameAr: 'حسبان', nameEn: 'Hesban' },
          { id: 'a-136', nameAr: 'المشتى', nameEn: 'Al-Mashta' },
          { id: 'a-137', nameAr: 'حي العوامل', nameEn: 'Hay Al-Awamel' },
          { id: 'a-138', nameAr: 'السلط الغربية', nameEn: 'West Salt' },
          { id: 'a-139', nameAr: 'طريق المطار', nameEn: 'Airport Road' },
          { id: 'a-140', nameAr: 'شارع الشهيد', nameEn: 'Al-Shaheed St' },
          { id: 'a-141', nameAr: 'شارع وصفي التل', nameEn: 'Wasfi Al-Tal St' },
          { id: 'a-142', nameAr: 'شارع الاستقلال', nameEn: 'Al-Istiqlal St' },
          { id: 'a-143', nameAr: 'شارع خلدا', nameEn: 'Khalda St' },
          { id: 'a-144', nameAr: 'شارع السعادة', nameEn: 'Al-Saadah St' },
          { id: 'a-145', nameAr: 'شارع عبدالله غوشة', nameEn: 'Abdullah Ghosheh St' },
          { id: 'a-146', nameAr: 'حي الخنساء', nameEn: 'Hay Al-Khansa' },
          { id: 'a-147', nameAr: 'حي الامير فيصل', nameEn: 'Hay Al-Amir Faisal' },
          { id: 'a-148', nameAr: 'شارع الملكة رانيا', nameEn: 'Queen Rania St' },
          { id: 'a-149', nameAr: 'الذراع الغربي', nameEn: 'Western Arm' },
          { id: 'a-150', nameAr: 'البنيات', nameEn: 'Al-Bunayyat' },
          { id: 'a-151', nameAr: 'حي الروابي', nameEn: 'Hay Al-Rawabi' },
          { id: 'a-152', nameAr: 'حي الاندلس', nameEn: 'Hay Al-Andalus' },
          { id: 'a-153', nameAr: 'العطارين', nameEn: 'Al-Attarin' },
          { id: 'a-154', nameAr: 'ابو العوف', nameEn: 'Abu Al-Ouf' },
          { id: 'a-155', nameAr: 'حي الملك طلال', nameEn: 'Hay King Talal' },
          { id: 'a-156', nameAr: 'ام زويتينة', nameEn: 'Um Zweitineh' },
          { id: 'a-157', nameAr: 'عرجان', nameEn: 'Arjan' },
          { id: 'a-158', nameAr: 'الدمينة', nameEn: 'Al-Damineh' },
          { id: 'a-159', nameAr: 'الماضونة', nameEn: 'Al-Madouneh' },
          { id: 'a-160', nameAr: 'المشيرفة', nameEn: 'Al-Mushairfeh' },
          { id: 'a-161', nameAr: 'ام الكندم', nameEn: 'Um Al-Kundum' },
          { id: 'a-162', nameAr: 'حي الصداقة', nameEn: 'Hay Al-Sadaqah' },
          { id: 'a-163', nameAr: 'حي الملك عبدالله', nameEn: 'Hay King Abdullah' },
          { id: 'a-164', nameAr: 'الكمالية', nameEn: 'Al-Kamaliyeh' },
          { id: 'a-165', nameAr: 'الامير علي', nameEn: 'Al-Amir Ali' },
          { id: 'a-166', nameAr: 'حي ابو حليقة', nameEn: 'Hay Abu Haliqah' },
          { id: 'a-167', nameAr: 'ام رمانة', nameEn: 'Um Rummanah' },
          { id: 'a-168', nameAr: 'البصة', nameEn: 'Al-Bassa' },
          { id: 'a-169', nameAr: 'الرابع عشر', nameEn: 'Fourteenth' },
          { id: 'a-170', nameAr: 'تلاع العلي الشمالي', nameEn: 'North Tla Al-Ali' },
          { id: 'a-171', nameAr: 'ام عبهرة', nameEn: 'Um Abharah' },
          { id: 'a-172', nameAr: 'حي العوجان', nameEn: 'Hay Al-Awjan' },
          { id: 'a-173', nameAr: 'حي النسيم', nameEn: 'Hay Al-Naseem' },
          { id: 'a-174', nameAr: 'حي الزيتونة', nameEn: 'Hay Al-Zaytouneh' },
          { id: 'a-175', nameAr: 'حي الصناعة', nameEn: 'Hay Al-Sinaa' },
          { id: 'a-176', nameAr: 'ضاحية الكرمل', nameEn: 'Dahyet Al-Karmel' },
          { id: 'a-177', nameAr: 'حي المنصورة', nameEn: 'Hay Al-Mansourah' },
          { id: 'a-178', nameAr: 'حي الاتحاد', nameEn: 'Hay Al-Ittihad' },
          { id: 'a-179', nameAr: 'ضاحية النخيل', nameEn: 'Dahyet Al-Nakheel' },
          { id: 'a-180', nameAr: 'حي القدس', nameEn: 'Hay Al-Quds' },
          { id: 'a-181', nameAr: 'ام طاقات', nameEn: 'Um Taqat' },
          { id: 'a-182', nameAr: 'حي النور', nameEn: 'Hay Al-Nour' },
          { id: 'a-183', nameAr: 'حي السلام', nameEn: 'Hay Al-Salam' },
          { id: 'a-184', nameAr: 'حي اليرموك', nameEn: 'Hay Al-Yarmouk' },
          { id: 'a-185', nameAr: 'حي الامل', nameEn: 'Hay Al-Amal' },
          { id: 'a-186', nameAr: 'المغاريب', nameEn: 'Al-Magharib' },
          { id: 'a-187', nameAr: 'ضاحية الجامعة', nameEn: 'Dahyet Al-Jameah' },
          { id: 'a-188', nameAr: 'حي العبور', nameEn: 'Hay Al-Obour' },
          { id: 'a-189', nameAr: 'حي الفردوس', nameEn: 'Hay Al-Firdaws' },
          { id: 'a-190', nameAr: 'تقاطع خلدا', nameEn: 'Khalda Junction' },
          { id: 'a-191', nameAr: 'حي الصفا', nameEn: 'Hay Al-Safa' },
          { id: 'a-192', nameAr: 'وادي الرمم', nameEn: 'Wadi Al-Rimam' },
          { id: 'a-193', nameAr: 'حنينا', nameEn: 'Hneina' },
          { id: 'a-194', nameAr: 'ماسية', nameEn: 'Masiyeh' },
          { id: 'a-195', nameAr: 'الحويطي', nameEn: 'Al-Hweiti' },
          { id: 'a-196', nameAr: 'ام الابار', nameEn: 'Um Al-Abar' },
          { id: 'a-197', nameAr: 'حي الملك حسين', nameEn: 'Hay King Hussein' },
          { id: 'a-198', nameAr: 'الصناعية', nameEn: 'Al-Sinaiyeh' },
          { id: 'a-199', nameAr: 'حي الوفاء', nameEn: 'Hay Al-Wafa' },
          { id: 'a-200', nameAr: 'شارع المستشفى', nameEn: 'Hospital St' },
          { id: 'a-201', nameAr: 'حي العز', nameEn: 'Hay Al-Izz' },
          { id: 'a-202', nameAr: 'ام حليليفة', nameEn: 'Um Hleileifeh' },
          { id: 'a-203', nameAr: 'حي ابو درويش', nameEn: 'Hay Abu Darweesh' },
          { id: 'a-204', nameAr: 'حي البركة', nameEn: 'Hay Al-Barakeh' },
          { id: 'a-205', nameAr: 'وادي عبدون', nameEn: 'Wadi Abdoun' },
          { id: 'a-206', nameAr: 'حي الخالدية', nameEn: 'Hay Al-Khaldiyeh' },
          { id: 'a-207', nameAr: 'حي المحبة', nameEn: 'Hay Al-Mahabbeh' },
          { id: 'a-208', nameAr: 'ام تينة', nameEn: 'Um Teenah' },
          { id: 'a-209', nameAr: 'الزميلة', nameEn: 'Al-Zmeilah' },
          { id: 'a-210', nameAr: 'ضاحية الاستقلال', nameEn: 'Dahyet Al-Istiqlal' },
          { id: 'a-211', nameAr: 'حي المجد', nameEn: 'Hay Al-Majd' },
          { id: 'a-212', nameAr: 'الدقمسة', nameEn: 'Al-Daqamseh' },
          { id: 'a-213', nameAr: 'ام بطمة', nameEn: 'Um Batmah' },
          { id: 'a-214', nameAr: 'حنوطية', nameEn: 'Hanoutiyeh' },
          { id: 'a-215', nameAr: 'الحصاد', nameEn: 'Al-Hasad' },
          { id: 'a-216', nameAr: 'منجا', nameEn: 'Manja' },
          { id: 'a-217', nameAr: 'خشافية', nameEn: 'Khashafiyeh' },
          { id: 'a-218', nameAr: 'حي الفاروق', nameEn: 'Hay Al-Farouq' },
          { id: 'a-219', nameAr: 'حي الشعب', nameEn: 'Hay Al-Shaab' },
          { id: 'a-220', nameAr: 'حي التضامن', nameEn: 'Hay Al-Tadamun' },
          { id: 'a-221', nameAr: 'وادي الحدادة', nameEn: 'Wadi Al-Haddadeh' },
          { id: 'a-222', nameAr: 'ام الاسود', nameEn: 'Um Al-Asoud' },
          { id: 'a-223', nameAr: 'القلة', nameEn: 'Al-Qulleh' },
          { id: 'a-224', nameAr: 'حي الجمعية', nameEn: 'Hay Al-Jamiyeh' },
          { id: 'a-225', nameAr: 'وادي السرور', nameEn: 'Wadi Al-Surour' },
          { id: 'a-226', nameAr: 'ضاحية الحاج حسن', nameEn: 'Dahyet Haj Hasan' },
          { id: 'a-227', nameAr: 'حي ابو نصير الغربي', nameEn: 'Abu Nseir West' },
          { id: 'a-228', nameAr: 'ضاحية المقاصيد', nameEn: 'Dahyet Al-Maqaseed' },
          { id: 'a-229', nameAr: 'جاوا', nameEn: 'Jawa' },
          { id: 'a-230', nameAr: 'ام البساتين', nameEn: 'Um Al-Basateen' },
          { id: 'a-231', nameAr: 'مغاير شعيب', nameEn: 'Maghayer Shuaib' },
          { id: 'a-232', nameAr: 'حي الكورنيش', nameEn: 'Hay Al-Corniche' },
          { id: 'a-233', nameAr: 'حي القناطر', nameEn: 'Hay Al-Qanatir' },
          { id: 'a-234', nameAr: 'حي الانوار', nameEn: 'Hay Al-Anwar' },
          { id: 'a-235', nameAr: 'حي الكوثر', nameEn: 'Hay Al-Kawthar' },
          { id: 'a-236', nameAr: 'حي الاسراء', nameEn: 'Hay Al-Isra' },
          { id: 'a-237', nameAr: 'حي المعراج', nameEn: 'Hay Al-Miraj' },
          { id: 'a-238', nameAr: 'ام الحلقان', nameEn: 'Um Al-Hilqan' },
          { id: 'a-239', nameAr: 'حي الجوهرة', nameEn: 'Hay Al-Jawhara' },
          { id: 'a-240', nameAr: 'حي التاج', nameEn: 'Hay Al-Taj' },
          { id: 'a-241', nameAr: 'ام رجم', nameEn: 'Um Rujm' },
          { id: 'a-242', nameAr: 'حي الجبيل', nameEn: 'Hay Al-Jubeil' },
          { id: 'a-243', nameAr: 'حي المطلع', nameEn: 'Hay Al-Matla' },
          { id: 'a-244', nameAr: 'ام القرى', nameEn: 'Um Al-Qura' },
          { id: 'a-245', nameAr: 'ام قص', nameEn: 'Um Quss' },
          { id: 'a-246', nameAr: 'الكعابنة', nameEn: 'Al-Kabaneh' },
          { id: 'a-247', nameAr: 'ام الدنانير', nameEn: 'Um Al-Dananeer' },
          { id: 'a-248', nameAr: 'حي البشير', nameEn: 'Hay Al-Bashir' },
          { id: 'a-249', nameAr: 'حي الضباط', nameEn: 'Hay Al-Dubbat' },
          { id: 'a-250', nameAr: 'حي المهندسين', nameEn: 'Hay Al-Muhandseen' },
          // === مناطق سحاب ===
          { id: 'a-251', nameAr: 'سحاب الشرقي', nameEn: 'East Sahab' },
          { id: 'a-252', nameAr: 'سحاب الغربي', nameEn: 'West Sahab' },
          { id: 'a-253', nameAr: 'سحاب الشمالي', nameEn: 'North Sahab' },
          { id: 'a-254', nameAr: 'سحاب الجنوبي', nameEn: 'South Sahab' },
          { id: 'a-255', nameAr: 'حي الامير محمد سحاب', nameEn: 'Hay Al-Amir Mohammad Sahab' },
          { id: 'a-256', nameAr: 'حي الزيتون سحاب', nameEn: 'Hay Al-Zaytoun Sahab' },
          { id: 'a-257', nameAr: 'حي الورود سحاب', nameEn: 'Hay Al-Wuroud Sahab' },
          { id: 'a-258', nameAr: 'المنطقة الصناعية سحاب', nameEn: 'Sahab Industrial Zone' },
          { id: 'a-259', nameAr: 'سوق سحاب التجاري', nameEn: 'Sahab Commercial Market' },
          { id: 'a-260', nameAr: 'حي الجامع الكبير سحاب', nameEn: 'Grand Mosque Area Sahab' },
          { id: 'a-261', nameAr: 'حي الهداية سحاب', nameEn: 'Hay Al-Hidayah Sahab' },
          { id: 'a-262', nameAr: 'مخيم سحاب', nameEn: 'Sahab Camp' },
          { id: 'a-263', nameAr: 'حي النصر سحاب', nameEn: 'Hay Al-Nasr Sahab' },
          { id: 'a-264', nameAr: 'حي الشهداء سحاب', nameEn: 'Hay Al-Shuhada Sahab' },
          { id: 'a-265', nameAr: 'شارع بغداد سحاب', nameEn: 'Baghdad St Sahab' },
          { id: 'a-266', nameAr: 'دوار سحاب', nameEn: 'Sahab Roundabout' },
          { id: 'a-267', nameAr: 'حي التطوير سحاب', nameEn: 'Hay Al-Tatweer Sahab' },
          { id: 'a-268', nameAr: 'حي الاسكان سحاب', nameEn: 'Hay Al-Iskan Sahab' },
          { id: 'a-269', nameAr: 'حي الامل سحاب', nameEn: 'Hay Al-Amal Sahab' },
          { id: 'a-270', nameAr: 'حي التعاون سحاب', nameEn: 'Hay Al-Taawun Sahab' },
          // === مناطق البيضاء ===
          { id: 'a-271', nameAr: 'البيضاء الشرقية', nameEn: 'East Al-Bayda' },
          { id: 'a-272', nameAr: 'البيضاء الغربية', nameEn: 'West Al-Bayda' },
          { id: 'a-273', nameAr: 'البيضاء الشمالية', nameEn: 'North Al-Bayda' },
          { id: 'a-274', nameAr: 'البيضاء الجنوبية', nameEn: 'South Al-Bayda' },
          { id: 'a-275', nameAr: 'حي الربيع البيضاء', nameEn: 'Hay Al-Rabie Al-Bayda' },
          { id: 'a-276', nameAr: 'حي الزهور البيضاء', nameEn: 'Hay Al-Zuhour Al-Bayda' },
          { id: 'a-277', nameAr: 'حي الامان البيضاء', nameEn: 'Hay Al-Aman Al-Bayda' },
          { id: 'a-278', nameAr: 'حي السعادة البيضاء', nameEn: 'Hay Al-Saadah Al-Bayda' },
          { id: 'a-279', nameAr: 'حي النزهة البيضاء', nameEn: 'Hay Al-Nuzha Al-Bayda' },
          { id: 'a-280', nameAr: 'حي البستان البيضاء', nameEn: 'Hay Al-Bustan Al-Bayda' },
          { id: 'a-281', nameAr: 'طريق البيضاء الرئيسي', nameEn: 'Al-Bayda Main Road' },
          { id: 'a-282', nameAr: 'مسجد البيضاء الكبير', nameEn: 'Al-Bayda Grand Mosque' },
          { id: 'a-283', nameAr: 'حي الخير البيضاء', nameEn: 'Hay Al-Khair Al-Bayda' },
          { id: 'a-284', nameAr: 'حي الهدى البيضاء', nameEn: 'Hay Al-Huda Al-Bayda' },
          { id: 'a-285', nameAr: 'حي التقوى البيضاء', nameEn: 'Hay Al-Taqwa Al-Bayda' },
          { id: 'a-286', nameAr: 'حي الفلاح البيضاء', nameEn: 'Hay Al-Falah Al-Bayda' },
          { id: 'a-287', nameAr: 'حي العروبة البيضاء', nameEn: 'Hay Al-Oroubah Al-Bayda' },
          { id: 'a-288', nameAr: 'حي المنار البيضاء', nameEn: 'Hay Al-Manar Al-Bayda' },
          { id: 'a-289', nameAr: 'حي الشروق البيضاء', nameEn: 'Hay Al-Shurouq Al-Bayda' },
          { id: 'a-290', nameAr: 'حي الوحدة البيضاء', nameEn: 'Hay Al-Wahdah Al-Bayda' },
          // === مناطق أحد ===
          { id: 'a-291', nameAr: 'احد الشرقي', nameEn: 'East Uhud' },
          { id: 'a-292', nameAr: 'احد الغربي', nameEn: 'West Uhud' },
          { id: 'a-293', nameAr: 'احد الشمالي', nameEn: 'North Uhud' },
          { id: 'a-294', nameAr: 'احد الجنوبي', nameEn: 'South Uhud' },
          { id: 'a-295', nameAr: 'حي السلام احد', nameEn: 'Hay Al-Salam Uhud' },
          { id: 'a-296', nameAr: 'حي الامل احد', nameEn: 'Hay Al-Amal Uhud' },
          { id: 'a-297', nameAr: 'حي النور احد', nameEn: 'Hay Al-Nour Uhud' },
          { id: 'a-298', nameAr: 'حي الايمان احد', nameEn: 'Hay Al-Iman Uhud' },
          { id: 'a-299', nameAr: 'حي الوفاء احد', nameEn: 'Hay Al-Wafa Uhud' },
          { id: 'a-300', nameAr: 'حي الصفا احد', nameEn: 'Hay Al-Safa Uhud' },
          { id: 'a-301', nameAr: 'حي المروة احد', nameEn: 'Hay Al-Marwa Uhud' },
          { id: 'a-302', nameAr: 'حي البركة احد', nameEn: 'Hay Al-Barakah Uhud' },
          { id: 'a-303', nameAr: 'حي الرحمة احد', nameEn: 'Hay Al-Rahmah Uhud' },
          { id: 'a-304', nameAr: 'حي التوحيد احد', nameEn: 'Hay Al-Tawheed Uhud' },
          { id: 'a-305', nameAr: 'حي الاسراء احد', nameEn: 'Hay Al-Isra Uhud' },
          { id: 'a-306', nameAr: 'حي القدس احد', nameEn: 'Hay Al-Quds Uhud' },
          { id: 'a-307', nameAr: 'مسجد احد الكبير', nameEn: 'Uhud Grand Mosque' },
          { id: 'a-308', nameAr: 'طريق احد الرئيسي', nameEn: 'Uhud Main Road' },
          { id: 'a-309', nameAr: 'حي الهداية احد', nameEn: 'Hay Al-Hidayah Uhud' },
          { id: 'a-310', nameAr: 'حي التقدم احد', nameEn: 'Hay Al-Taqaddum Uhud' },
          // === مناطق الموقر ===
          { id: 'a-311', nameAr: 'الموقر الشرقي', nameEn: 'East Muwaqqar' },
          { id: 'a-312', nameAr: 'الموقر الغربي', nameEn: 'West Muwaqqar' },
          { id: 'a-313', nameAr: 'الموقر الشمالي', nameEn: 'North Muwaqqar' },
          { id: 'a-314', nameAr: 'الموقر الجنوبي', nameEn: 'South Muwaqqar' },
          { id: 'a-315', nameAr: 'حي الامير حسين الموقر', nameEn: 'Hay Al-Amir Hussein Muwaqqar' },
          { id: 'a-316', nameAr: 'منطقة الخشافية', nameEn: 'Khashafiyeh Area' },
          { id: 'a-317', nameAr: 'الرجم الشامي', nameEn: 'Al-Rujm Al-Shami' },
          { id: 'a-318', nameAr: 'المنطقة الصناعية الموقر', nameEn: 'Muwaqqar Industrial Zone' },
          { id: 'a-319', nameAr: 'حي الجامع الموقر', nameEn: 'Mosque Area Muwaqqar' },
          { id: 'a-320', nameAr: 'حي البلدية الموقر', nameEn: 'Municipality Area Muwaqqar' },
          { id: 'a-321', nameAr: 'ام الوليد', nameEn: 'Um Al-Waleed' },
          { id: 'a-322', nameAr: 'ام الجمال الموقر', nameEn: 'Um Al-Jamal Muwaqqar' },
          { id: 'a-323', nameAr: 'حي السكة الموقر', nameEn: 'Hay Al-Sikkeh Muwaqqar' },
          { id: 'a-324', nameAr: 'حي الميدان الموقر', nameEn: 'Hay Al-Maydan Muwaqqar' },
          { id: 'a-325', nameAr: 'الضليل', nameEn: 'Al-Dleil' },
          { id: 'a-326', nameAr: 'حي الشهيد الموقر', nameEn: 'Hay Al-Shaheed Muwaqqar' },
          { id: 'a-327', nameAr: 'حي الفيحاء الموقر', nameEn: 'Hay Al-Fayha Muwaqqar' },
          { id: 'a-328', nameAr: 'حي النهضة الموقر', nameEn: 'Hay Al-Nahdah Muwaqqar' },
          { id: 'a-329', nameAr: 'حي الربوة الموقر', nameEn: 'Hay Al-Rabwah Muwaqqar' },
          { id: 'a-330', nameAr: 'الحلابات', nameEn: 'Al-Hallabat' },
        ],
      },
      {
        id: 'jo-2', nameAr: 'اربد', nameEn: 'Irbid',
        areas: [
          { id: 'ir-1', nameAr: 'وسط اربد', nameEn: 'Irbid Downtown' },
          { id: 'ir-2', nameAr: 'الحصن', nameEn: 'Al-Husn' },
          { id: 'ir-3', nameAr: 'ايدون', nameEn: 'Aidoun' },
          { id: 'ir-4', nameAr: 'بيت راس', nameEn: 'Beit Ras' },
          { id: 'ir-5', nameAr: 'الرمثا', nameEn: 'Al-Ramtha' },
          { id: 'ir-6', nameAr: 'الطيبة', nameEn: 'Al-Taybeh' },
          { id: 'ir-7', nameAr: 'المزار الشمالي', nameEn: 'Al-Mazar Al-Shamali' },
          { id: 'ir-8', nameAr: 'الكورة', nameEn: 'Al-Koura' },
          { id: 'ir-9', nameAr: 'بني كنانة', nameEn: 'Bani Kinanah' },
          { id: 'ir-10', nameAr: 'بني عبيد', nameEn: 'Bani Obeid' },
          { id: 'ir-11', nameAr: 'الاغوار الشمالية', nameEn: 'Northern Ghors' },
          { id: 'ir-12', nameAr: 'الوسطية', nameEn: 'Al-Wastiyyeh' },
          { id: 'ir-13', nameAr: 'حوارة', nameEn: 'Hawwarah' },
          { id: 'ir-14', nameAr: 'سال', nameEn: 'Sal' },
          { id: 'ir-15', nameAr: 'كفر يوبا', nameEn: 'Kufr Yuba' },
          { id: 'ir-16', nameAr: 'النعيمة', nameEn: 'Al-Naymeh' },
          { id: 'ir-17', nameAr: 'حكما', nameEn: 'Hakama' },
          { id: 'ir-18', nameAr: 'الصريح', nameEn: 'Al-Sarih' },
          { id: 'ir-19', nameAr: 'كفر اسد', nameEn: 'Kufr Asad' },
          { id: 'ir-20', nameAr: 'كفر سوم', nameEn: 'Kufr Soum' },
          { id: 'ir-21', nameAr: 'كفر الماء', nameEn: 'Kufr Al-Ma' },
          { id: 'ir-22', nameAr: 'كفر راكب', nameEn: 'Kufr Rakeb' },
          { id: 'ir-23', nameAr: 'كفر عوان', nameEn: 'Kufr Awan' },
          { id: 'ir-24', nameAr: 'بشرى', nameEn: 'Bushra' },
          { id: 'ir-25', nameAr: 'سمر', nameEn: 'Samar' },
          { id: 'ir-26', nameAr: 'قميم', nameEn: 'Qumeim' },
          { id: 'ir-27', nameAr: 'ارحاب', nameEn: 'Arhab' },
          { id: 'ir-28', nameAr: 'ملكا', nameEn: 'Malka' },
          { id: 'ir-29', nameAr: 'حبكا', nameEn: 'Habaka' },
          { id: 'ir-30', nameAr: 'سحم الكفارات', nameEn: 'Saham Al-Kafarat' },
          { id: 'ir-31', nameAr: 'دير ابي سعيد', nameEn: 'Deir Abi Saeed' },
          { id: 'ir-32', nameAr: 'جديتا', nameEn: 'Jdeita' },
          { id: 'ir-33', nameAr: 'تبنة', nameEn: 'Tibneh' },
          { id: 'ir-34', nameAr: 'زحر', nameEn: 'Zahar' },
          { id: 'ir-35', nameAr: 'علعال', nameEn: 'Al-Alal' },
          { id: 'ir-36', nameAr: 'دوقرة', nameEn: 'Duqarah' },
          { id: 'ir-37', nameAr: 'حبراص', nameEn: 'Habras' },
          { id: 'ir-38', nameAr: 'كتم', nameEn: 'Kitm' },
          { id: 'ir-39', nameAr: 'جامعة اليرموك', nameEn: 'Yarmouk University' },
          { id: 'ir-40', nameAr: 'جامعة العلوم والتكنولوجيا', nameEn: 'JUST University' },
          { id: 'ir-41', nameAr: 'ارباين', nameEn: 'Arbain' },
          { id: 'ir-42', nameAr: 'الحي الشرقي', nameEn: 'Eastern Quarter' },
          { id: 'ir-43', nameAr: 'الحي الغربي', nameEn: 'Western Quarter' },
          { id: 'ir-44', nameAr: 'المجمع الجديد', nameEn: 'New Complex' },
          { id: 'ir-45', nameAr: 'شارع الجامعة', nameEn: 'University St.' },
          { id: 'ir-46', nameAr: 'شارع فلسطين', nameEn: 'Palestine St.' },
          { id: 'ir-47', nameAr: 'شارع الحصن', nameEn: 'Al-Husn St.' },
          { id: 'ir-48', nameAr: 'برقش', nameEn: 'Barqash' },
          { id: 'ir-49', nameAr: 'زبدة', nameEn: 'Zabda' },
          { id: 'ir-50', nameAr: 'سموع', nameEn: 'Samou' },
          { id: 'ir-51', nameAr: 'حواره الغربية', nameEn: 'Hawwarah West' },
          { id: 'ir-52', nameAr: 'الحي الجنوبي', nameEn: 'Southern Quarter' },
          { id: 'ir-53', nameAr: 'مخيم اربد', nameEn: 'Irbid Camp' },
          { id: 'ir-54', nameAr: 'مخيم الحصن', nameEn: 'Al-Husn Camp' },
          { id: 'ir-55', nameAr: 'حي التركمان', nameEn: 'Turkman Quarter' },
          { id: 'ir-56', nameAr: 'الحي الهاشمي', nameEn: 'Hashmi Quarter' },
          { id: 'ir-57', nameAr: 'حي الافراح', nameEn: 'Hay Al-Afrah' },
          { id: 'ir-58', nameAr: 'حي القصيلة', nameEn: 'Hay Al-Qusaileh' },
          { id: 'ir-59', nameAr: 'حي الورود', nameEn: 'Hay Al-Wuroud' },
          { id: 'ir-60', nameAr: 'حي الزهور', nameEn: 'Hay Al-Zuhour' },
          { id: 'ir-61', nameAr: 'شارع بغداد', nameEn: 'Baghdad St' },
          { id: 'ir-62', nameAr: 'شارع الثلاثين', nameEn: 'Thirty St' },
          { id: 'ir-63', nameAr: 'الرمثا الشرقية', nameEn: 'Ramtha East' },
          { id: 'ir-64', nameAr: 'الرمثا الغربية', nameEn: 'Ramtha West' },
          { id: 'ir-65', nameAr: 'الطوال', nameEn: 'Al-Tuwal' },
          { id: 'ir-66', nameAr: 'الشيخ حسين', nameEn: 'Sheikh Hussein' },
          { id: 'ir-67', nameAr: 'حي النزهة', nameEn: 'Hay Al-Nuzha' },
          { id: 'ir-68', nameAr: 'حي الراهبات', nameEn: 'Hay Al-Rahibat' },
          { id: 'ir-69', nameAr: 'دوار الثقافة', nameEn: 'Culture Circle' },
          { id: 'ir-70', nameAr: 'مجمع عمان', nameEn: 'Amman Complex' },
          { id: 'ir-71', nameAr: 'حي الملك عبدالله', nameEn: 'Hay King Abdullah' },
          { id: 'ir-72', nameAr: 'حي الاميرة بسمة', nameEn: 'Hay Al-Amira Basma' },
          { id: 'ir-73', nameAr: 'حي الملك حسين', nameEn: 'Hay King Hussein' },
          { id: 'ir-74', nameAr: 'حي التطوير الحضري', nameEn: 'Urban Dev Quarter' },
          { id: 'ir-75', nameAr: 'شارع الاردن', nameEn: 'Jordan St.' },
          { id: 'ir-76', nameAr: 'شارع القدس', nameEn: 'Al-Quds St.' },
          { id: 'ir-77', nameAr: 'دوار الشهداء', nameEn: 'Martyrs Circle' },
          { id: 'ir-78', nameAr: 'دوار الاستقلال', nameEn: 'Independence Circle' },
          { id: 'ir-79', nameAr: 'حي الكرامة', nameEn: 'Hay Al-Karameh' },
          { id: 'ir-80', nameAr: 'حي المنصور', nameEn: 'Hay Al-Mansour' },
          { id: 'ir-81', nameAr: 'حي الضباط', nameEn: 'Hay Al-Dubbat' },
          { id: 'ir-82', nameAr: 'حي الاسكان', nameEn: 'Hay Al-Iskan' },
          { id: 'ir-83', nameAr: 'حي المرج', nameEn: 'Hay Al-Marj' },
          { id: 'ir-84', nameAr: 'حي الريان', nameEn: 'Hay Al-Rayyan' },
          { id: 'ir-85', nameAr: 'حي البركة', nameEn: 'Hay Al-Barakeh' },
          { id: 'ir-86', nameAr: 'حي السلام', nameEn: 'Hay Al-Salam' },
          { id: 'ir-87', nameAr: 'حي النهضة', nameEn: 'Hay Al-Nahdah' },
          { id: 'ir-88', nameAr: 'شارع السينما', nameEn: 'Cinema St.' },
          { id: 'ir-89', nameAr: 'شارع النزهة', nameEn: 'Nuzha St.' },
          { id: 'ir-90', nameAr: 'منطقة البارحة', nameEn: 'Al-Barihah Area' },
          { id: 'ir-91', nameAr: 'حي النصر', nameEn: 'Hay Al-Nasr' },
          { id: 'ir-92', nameAr: 'الباعوص', nameEn: 'Al-Baous' },
          { id: 'ir-93', nameAr: 'شارع الملك فيصل', nameEn: 'King Faisal St.' },
          { id: 'ir-94', nameAr: 'حي الاطباء', nameEn: 'Hay Al-Atibba' },
          { id: 'ir-95', nameAr: 'حي الجامعة', nameEn: 'Hay Al-Jameah' },
          { id: 'ir-96', nameAr: 'مجمع الشيخ خليل', nameEn: 'Sheikh Khalil Complex' },
          { id: 'ir-97', nameAr: 'خلف المستشفى الحكومي', nameEn: 'Behind Gov. Hospital' },
          { id: 'ir-98', nameAr: 'حي الميدان', nameEn: 'Hay Al-Maidan' },
          { id: 'ir-99', nameAr: 'حي الانتاج', nameEn: 'Hay Al-Intaj' },
          { id: 'ir-100', nameAr: 'شارع الهاشمي', nameEn: 'Hashmi St.' },
          { id: 'ir-101', nameAr: 'حي الاقصى', nameEn: 'Hay Al-Aqsa' },
          { id: 'ir-102', nameAr: 'تقاطع الصريح', nameEn: 'Al-Sarih Junction' },
          { id: 'ir-103', nameAr: 'حي التوفيق', nameEn: 'Hay Al-Tawfiq' },
          { id: 'ir-104', nameAr: 'حي الهدى', nameEn: 'Hay Al-Huda' },
          { id: 'ir-105', nameAr: 'مجمع الاغوار', nameEn: 'Aghwar Complex' },
          { id: 'ir-106', nameAr: 'حي الحسام', nameEn: 'Hay Al-Husam' },
          { id: 'ir-107', nameAr: 'شارع حبراص', nameEn: 'Habras St.' },
          { id: 'ir-108', nameAr: 'شارع المنشية', nameEn: 'Manshiyeh St.' },
          { id: 'ir-109', nameAr: 'مثلث القبة', nameEn: 'Al-Qubbah Triangle' },
          { id: 'ir-110', nameAr: 'حي الصلاح', nameEn: 'Hay Al-Salah' },
          { id: 'ir-111', nameAr: 'شارع الحدائق', nameEn: 'Gardens St.' },
          { id: 'ir-112', nameAr: 'حي المزرعة', nameEn: 'Hay Al-Mazraah' },
          { id: 'ir-113', nameAr: 'حي القبة', nameEn: 'Hay Al-Qubbah' },
          { id: 'ir-114', nameAr: 'حي الحرش', nameEn: 'Hay Al-Hirsh' },
          { id: 'ir-115', nameAr: 'حي المستشفى التخصصي', nameEn: 'Specialty Hospital Quarter' },
          { id: 'ir-116', nameAr: 'المعارض', nameEn: 'Al-Maaridh' },
          { id: 'ir-117', nameAr: 'مجمع البلدية', nameEn: 'Municipality Complex' },
          { id: 'ir-118', nameAr: 'حي الاعلام', nameEn: 'Hay Al-Ilam' },
          { id: 'ir-119', nameAr: 'المنطقة الحرة', nameEn: 'Free Zone' },
          { id: 'ir-120', nameAr: 'شارع فوعرا', nameEn: 'Foarah St.' },
          { id: 'ir-121', nameAr: 'حي الجنينة', nameEn: 'Hay Al-Junaynah' },
          { id: 'ir-122', nameAr: 'الحارة الشرقية', nameEn: 'Eastern Harah' },
          { id: 'ir-123', nameAr: 'الحارة الغربية', nameEn: 'Western Harah' },
          { id: 'ir-124', nameAr: 'مجمع الاسواق', nameEn: 'Markets Complex' },
          { id: 'ir-125', nameAr: 'حي التلفزيون', nameEn: 'Hay Al-Television' },
          { id: 'ir-126', nameAr: 'حي النور', nameEn: 'Hay Al-Nour' },
          { id: 'ir-127', nameAr: 'حي الاشجار', nameEn: 'Hay Al-Ashjar' },
          { id: 'ir-128', nameAr: 'حي العودة', nameEn: 'Hay Al-Awdah' },
          { id: 'ir-129', nameAr: 'حي الوادي', nameEn: 'Hay Al-Wadi' },
          { id: 'ir-130', nameAr: 'شارع الملك عبدالله الثاني', nameEn: 'King Abdullah II St.' },
          { id: 'ir-131', nameAr: 'حي الامل', nameEn: 'Hay Al-Amal' },
          { id: 'ir-132', nameAr: 'حي الندى', nameEn: 'Hay Al-Nada' },
          { id: 'ir-133', nameAr: 'مثلث ايدون', nameEn: 'Aidoun Triangle' },
          { id: 'ir-134', nameAr: 'حي العقبة', nameEn: 'Hay Al-Aqabah' },
          { id: 'ir-135', nameAr: 'حي الصفاء', nameEn: 'Hay Al-Safaa' },
          { id: 'ir-136', nameAr: 'حي الفاروق', nameEn: 'Hay Al-Farouq' },
          { id: 'ir-137', nameAr: 'حي الياسمين', nameEn: 'Hay Al-Yasmin' },
          { id: 'ir-138', nameAr: 'حي الوحدة', nameEn: 'Hay Al-Wahdah' },
          { id: 'ir-139', nameAr: 'حي الخضراء', nameEn: 'Hay Al-Khadra' },
          { id: 'ir-140', nameAr: 'حي البيارة', nameEn: 'Hay Al-Bayarah' },
          { id: 'ir-141', nameAr: 'دوار المدينة', nameEn: 'City Circle' },
          { id: 'ir-142', nameAr: 'حي الابرار', nameEn: 'Hay Al-Abrar' },
          { id: 'ir-143', nameAr: 'حي الرحمة', nameEn: 'Hay Al-Rahmah' },
          { id: 'ir-144', nameAr: 'حي الفلاح', nameEn: 'Hay Al-Falah' },
          { id: 'ir-145', nameAr: 'حي الاندلس', nameEn: 'Hay Al-Andalus' },
          { id: 'ir-146', nameAr: 'الوطية', nameEn: 'Al-Watiyeh' },
          { id: 'ir-147', nameAr: 'حي التقدم', nameEn: 'Hay Al-Taqaddum' },
          { id: 'ir-148', nameAr: 'حي البلد القديم', nameEn: 'Old Town Quarter' },
          { id: 'ir-149', nameAr: 'حي الجسر', nameEn: 'Hay Al-Jisr' },
          { id: 'ir-150', nameAr: 'شارع الرمثا', nameEn: 'Ramtha St.' },
          { id: 'ir-151', nameAr: 'حي المحكمة', nameEn: 'Hay Al-Mahkamah' },
          { id: 'ir-152', nameAr: 'حي البلدية', nameEn: 'Hay Al-Baladiyeh' },
          { id: 'ir-153', nameAr: 'حي الاتحاد', nameEn: 'Hay Al-Ittihad' },
          { id: 'ir-154', nameAr: 'حي الامير راشد', nameEn: 'Hay Al-Amir Rashed' },
          { id: 'ir-155', nameAr: 'حي الامير حسن', nameEn: 'Hay Al-Amir Hasan' },
          { id: 'ir-156', nameAr: 'حي الشاطئ', nameEn: 'Hay Al-Shati' },
          { id: 'ir-157', nameAr: 'حي الفيحاء', nameEn: 'Hay Al-Fayha' },
          { id: 'ir-158', nameAr: 'حي الفتح', nameEn: 'Hay Al-Fath' },
          { id: 'ir-159', nameAr: 'حي التعاون', nameEn: 'Hay Al-Taawun' },
          { id: 'ir-160', nameAr: 'حي الحصاد', nameEn: 'Hay Al-Hasad' },
          { id: 'ir-161', nameAr: 'شارع الملكة نور', nameEn: 'Queen Noor St.' },
          { id: 'ir-162', nameAr: 'حي العرب', nameEn: 'Hay Al-Arab' },
          { id: 'ir-163', nameAr: 'حي السبيل', nameEn: 'Hay Al-Sabeel' },
          { id: 'ir-164', nameAr: 'حي الدرة', nameEn: 'Hay Al-Durrah' },
          { id: 'ir-165', nameAr: 'مسجد حسن التل', nameEn: 'Hasan Al-Tal Mosque' },
          { id: 'ir-166', nameAr: 'دوار القبة', nameEn: 'Al-Qubbah Circle' },
          { id: 'ir-167', nameAr: 'حي الزراعة', nameEn: 'Hay Al-Ziraa' },
          { id: 'ir-168', nameAr: 'حي الورشة', nameEn: 'Hay Al-Warshah' },
          { id: 'ir-169', nameAr: 'حي الروضة', nameEn: 'Hay Al-Rawdah' },
          { id: 'ir-170', nameAr: 'حي المعلمين', nameEn: 'Hay Al-Mualimeen' },
        ],
      },
      {
        id: 'jo-3', nameAr: 'الزرقاء', nameEn: 'Zarqa',
        areas: [
          { id: 'zr-1', nameAr: 'وسط الزرقاء', nameEn: 'Zarqa Downtown' },
          { id: 'zr-2', nameAr: 'الرصيفة', nameEn: 'Al-Rusaifah' },
          { id: 'zr-3', nameAr: 'جبل الاميرة رحمة', nameEn: 'Jabal Al-Amira Rahma' },
          { id: 'zr-4', nameAr: 'الزرقاء الجديدة', nameEn: 'New Zarqa' },
          { id: 'zr-5', nameAr: 'هاشمية', nameEn: 'Hashmieh' },
          { id: 'zr-6', nameAr: 'بيرين', nameEn: 'Birin' },
          { id: 'zr-7', nameAr: 'الضليل', nameEn: 'Al-Dhleil' },
          { id: 'zr-8', nameAr: 'جناعة', nameEn: 'Jnaa' },
          { id: 'zr-9', nameAr: 'الحلابات', nameEn: 'Al-Hallabat' },
          { id: 'zr-10', nameAr: 'السخنة', nameEn: 'Al-Sukhneh' },
          { id: 'zr-11', nameAr: 'جبل الاميرة حياة', nameEn: 'Jabal Al-Amira Hayat' },
          { id: 'zr-12', nameAr: 'جبل طارق', nameEn: 'Jabal Tariq' },
          { id: 'zr-13', nameAr: 'الغويرية', nameEn: 'Al-Ghweiriyyeh' },
          { id: 'zr-14', nameAr: 'معصوم', nameEn: 'Massoum' },
          { id: 'zr-15', nameAr: 'حي الامير محمد', nameEn: 'Hay Al-Amir Mohammad' },
          { id: 'zr-16', nameAr: 'حي الحسين', nameEn: 'Hay Al-Hussein' },
          { id: 'zr-17', nameAr: 'حي رمزي', nameEn: 'Hay Ramzi' },
          { id: 'zr-18', nameAr: 'حي معصوم', nameEn: 'Hay Massoum' },
          { id: 'zr-19', nameAr: 'حي الامير حسن', nameEn: 'Hay Al-Amir Hasan' },
          { id: 'zr-20', nameAr: 'جبل الاميرة عالية', nameEn: 'Jabal Al-Amira Alia' },
          { id: 'zr-21', nameAr: 'الاوتوستراد', nameEn: 'Autostrad' },
          { id: 'zr-22', nameAr: 'المدينة الصناعية', nameEn: 'Industrial City' },
          { id: 'zr-23', nameAr: 'شومر', nameEn: 'Shomer' },
          { id: 'zr-24', nameAr: 'القادسية', nameEn: 'Al-Qadisiyeh' },
          { id: 'zr-25', nameAr: 'حي الجنينة', nameEn: 'Hay Al-Junaynah' },
          { id: 'zr-26', nameAr: 'حي الاطفائية', nameEn: 'Hay Al-Itfa\'iyeh' },
          { id: 'zr-27', nameAr: 'العوجان', nameEn: 'Al-Awjan' },
          { id: 'zr-28', nameAr: 'وادي الحجر', nameEn: 'Wadi Al-Hajar' },
          { id: 'zr-29', nameAr: 'حي الجنينة الجنوبي', nameEn: 'South Junaynah' },
          { id: 'zr-30', nameAr: 'حي الامير عبدالله', nameEn: 'Hay Al-Amir Abdullah' },
          { id: 'zr-31', nameAr: 'حي الحجوي', nameEn: 'Hay Al-Hajawi' },
          { id: 'zr-32', nameAr: 'حي البتراوي', nameEn: 'Hay Al-Batrawi' },
          { id: 'zr-33', nameAr: 'حي الزواهرة', nameEn: 'Hay Al-Zawahreh' },
          { id: 'zr-34', nameAr: 'حي المعصوم الشمالي', nameEn: 'North Massoum' },
          { id: 'zr-35', nameAr: 'جبل الاميرة سلمى', nameEn: 'Jabal Al-Amira Salma' },
          { id: 'zr-36', nameAr: 'الضليل الشمالي', nameEn: 'North Dhleil' },
          { id: 'zr-37', nameAr: 'الضليل الجنوبي', nameEn: 'South Dhleil' },
          { id: 'zr-38', nameAr: 'مخيم الزرقاء', nameEn: 'Zarqa Camp' },
          { id: 'zr-39', nameAr: 'حي الغويرية الشمالي', nameEn: 'North Ghweiriyyeh' },
          { id: 'zr-40', nameAr: 'حي النصر', nameEn: 'Hay Al-Nasr' },
          { id: 'zr-41', nameAr: 'حي الصناعة', nameEn: 'Hay Al-Sinaa' },
          { id: 'zr-42', nameAr: 'حي الامير محمد الجنوبي', nameEn: 'South Amir Mohammad' },
          { id: 'zr-43', nameAr: 'سوق الخضار المركزي', nameEn: 'Central Vegetable Market' },
          { id: 'zr-44', nameAr: 'حي الفلاح', nameEn: 'Hay Al-Falah' },
          { id: 'zr-45', nameAr: 'مخيم حطين', nameEn: 'Hitteen Camp' },
          { id: 'zr-46', nameAr: 'جبل الاميرة بسمة', nameEn: 'Jabal Al-Amira Basma' },
          { id: 'zr-47', nameAr: 'حي المحمود', nameEn: 'Hay Al-Mahmoud' },
          { id: 'zr-48', nameAr: 'شارع الملك عبدالله', nameEn: 'King Abdullah St' },
          { id: 'zr-49', nameAr: 'شارع السعادة', nameEn: 'Al-Saadah St' },
          { id: 'zr-50', nameAr: 'شارع ابو بكر الصديق', nameEn: 'Abu Bakr St' },
          { id: 'zr-51', nameAr: 'حي الامير حسين', nameEn: 'Hay Al-Amir Hussein' },
          { id: 'zr-52', nameAr: 'حي الرشيد', nameEn: 'Hay Al-Rasheed' },
          { id: 'zr-53', nameAr: 'حي الضياء', nameEn: 'Hay Al-Diyaa' },
          { id: 'zr-54', nameAr: 'حي المعلمين', nameEn: 'Hay Al-Mualimeen' },
          { id: 'zr-55', nameAr: 'حي الكرامة', nameEn: 'Hay Al-Karameh' },
          { id: 'zr-56', nameAr: 'حي الهاشمية', nameEn: 'Hay Al-Hashimiyeh' },
          { id: 'zr-57', nameAr: 'حي الاميرة عالية', nameEn: 'Hay Al-Amira Alia' },
          { id: 'zr-58', nameAr: 'حي النهضة', nameEn: 'Hay Al-Nahdah' },
          { id: 'zr-59', nameAr: 'حي الاسكان العسكري', nameEn: 'Military Housing' },
          { id: 'zr-60', nameAr: 'حي الجنوبي', nameEn: 'Southern Quarter' },
          { id: 'zr-61', nameAr: 'حي الشمالي', nameEn: 'Northern Quarter' },
          { id: 'zr-62', nameAr: 'حي السلام', nameEn: 'Hay Al-Salam' },
          { id: 'zr-63', nameAr: 'حي المنارة', nameEn: 'Hay Al-Manarah' },
          { id: 'zr-64', nameAr: 'حي الزهراء', nameEn: 'Hay Al-Zahra' },
          { id: 'zr-65', nameAr: 'حي العمال', nameEn: 'Hay Al-Ummal' },
          { id: 'zr-66', nameAr: 'حي التطوير', nameEn: 'Hay Al-Tatweer' },
          { id: 'zr-67', nameAr: 'حي الورود', nameEn: 'Hay Al-Wuroud' },
          { id: 'zr-68', nameAr: 'حي المهندسين', nameEn: 'Hay Al-Muhandseen' },
          { id: 'zr-69', nameAr: 'حي الامل', nameEn: 'Hay Al-Amal' },
          { id: 'zr-70', nameAr: 'حي المدينة', nameEn: 'Hay Al-Madinah' },
          { id: 'zr-71', nameAr: 'شارع الملك حسين', nameEn: 'King Hussein St' },
          { id: 'zr-72', nameAr: 'حي الجمعية', nameEn: 'Hay Al-Jamiyeh' },
          { id: 'zr-73', nameAr: 'شارع العرب', nameEn: 'Al-Arab St' },
          { id: 'zr-74', nameAr: 'حي البساتين', nameEn: 'Hay Al-Basateen' },
          { id: 'zr-75', nameAr: 'حي الوفاء', nameEn: 'Hay Al-Wafa' },
          { id: 'zr-76', nameAr: 'حي البلدية', nameEn: 'Hay Al-Baladiyeh' },
          { id: 'zr-77', nameAr: 'حي التقدم', nameEn: 'Hay Al-Taqaddum' },
          { id: 'zr-78', nameAr: 'حي الفيحاء', nameEn: 'Hay Al-Fayha' },
          { id: 'zr-79', nameAr: 'حي القدس', nameEn: 'Hay Al-Quds' },
          { id: 'zr-80', nameAr: 'حي الروضة', nameEn: 'Hay Al-Rawdah' },
          { id: 'zr-81', nameAr: 'حي الرياض', nameEn: 'Hay Al-Riyadh' },
          { id: 'zr-82', nameAr: 'حي الصفا', nameEn: 'Hay Al-Safa' },
          { id: 'zr-83', nameAr: 'حي الندى', nameEn: 'Hay Al-Nada' },
          { id: 'zr-84', nameAr: 'حي الخليل', nameEn: 'Hay Al-Khaleel' },
          { id: 'zr-85', nameAr: 'حي اليرموك', nameEn: 'Hay Al-Yarmouk' },
          { id: 'zr-86', nameAr: 'حي الربوة', nameEn: 'Hay Al-Rabwah' },
          { id: 'zr-87', nameAr: 'حي الشهداء', nameEn: 'Hay Al-Shuhada' },
          { id: 'zr-88', nameAr: 'حي الفردوس', nameEn: 'Hay Al-Firdaws' },
          { id: 'zr-89', nameAr: 'حي الاندلس', nameEn: 'Hay Al-Andalus' },
          { id: 'zr-90', nameAr: 'حي الرمال', nameEn: 'Hay Al-Rimal' },
          { id: 'zr-91', nameAr: 'حي الخزنة', nameEn: 'Hay Al-Khazna' },
          { id: 'zr-92', nameAr: 'حي التوفيق', nameEn: 'Hay Al-Tawfiq' },
          { id: 'zr-93', nameAr: 'شارع الامير محمد', nameEn: 'Al-Amir Mohammad St' },
          { id: 'zr-94', nameAr: 'حي التين', nameEn: 'Hay Al-Teen' },
          { id: 'zr-95', nameAr: 'حي الزيتون', nameEn: 'Hay Al-Zaytoun' },
          { id: 'zr-96', nameAr: 'سوق الزرقاء الشعبي', nameEn: 'Zarqa Popular Market' },
          { id: 'zr-97', nameAr: 'حي الاشجار', nameEn: 'Hay Al-Ashjar' },
          { id: 'zr-98', nameAr: 'حي القناطر', nameEn: 'Hay Al-Qanatir' },
          { id: 'zr-99', nameAr: 'شارع الاستقلال', nameEn: 'Al-Istiqlal St' },
          { id: 'zr-100', nameAr: 'حي الجزائر', nameEn: 'Hay Al-Jazair' },
          { id: 'zr-101', nameAr: 'حي الاردن', nameEn: 'Hay Al-Urdun' },
          { id: 'zr-102', nameAr: 'حي الضمير', nameEn: 'Hay Al-Dameer' },
          { id: 'zr-103', nameAr: 'حي الكوثر', nameEn: 'Hay Al-Kawthar' },
          { id: 'zr-104', nameAr: 'حي الحنين', nameEn: 'Hay Al-Haneen' },
          { id: 'zr-105', nameAr: 'الرصيفة الشمالية', nameEn: 'North Rusaifah' },
          { id: 'zr-106', nameAr: 'الرصيفة الجنوبية', nameEn: 'South Rusaifah' },
          { id: 'zr-107', nameAr: 'حي المغيرات', nameEn: 'Hay Al-Mughayyarat' },
          { id: 'zr-108', nameAr: 'حي العرفان', nameEn: 'Hay Al-Irfan' },
          { id: 'zr-109', nameAr: 'حي الخير', nameEn: 'Hay Al-Khair' },
          { id: 'zr-110', nameAr: 'شارع الاذاعة', nameEn: 'Radio St' },
          { id: 'zr-111', nameAr: 'حي الفيصل', nameEn: 'Hay Al-Faisal' },
          { id: 'zr-112', nameAr: 'حي الصخرة', nameEn: 'Hay Al-Sakhra' },
          { id: 'zr-113', nameAr: 'حي النخيل', nameEn: 'Hay Al-Nakheel' },
          { id: 'zr-114', nameAr: 'الهاشمية الشمالية', nameEn: 'North Hashmieh' },
          { id: 'zr-115', nameAr: 'الهاشمية الجنوبية', nameEn: 'South Hashmieh' },
          { id: 'zr-116', nameAr: 'حي الجامعة', nameEn: 'Hay Al-Jameah' },
          { id: 'zr-117', nameAr: 'جامعة الزرقاء', nameEn: 'Zarqa University' },
          { id: 'zr-118', nameAr: 'جامعة الهاشمية', nameEn: 'Hashemite University' },
          { id: 'zr-119', nameAr: 'حي المستشفى', nameEn: 'Hay Al-Mustashfa' },
          { id: 'zr-120', nameAr: 'حي الشهيد', nameEn: 'Hay Al-Shaheed' },
          { id: 'zr-121', nameAr: 'حي الملك طلال', nameEn: 'Hay King Talal' },
          { id: 'zr-122', nameAr: 'حي الملك عبدالله', nameEn: 'Hay King Abdullah' },
          { id: 'zr-123', nameAr: 'حي الرحاب', nameEn: 'Hay Al-Rihab' },
          { id: 'zr-124', nameAr: 'مخيم سكنة', nameEn: 'Sukneh Camp' },
          { id: 'zr-125', nameAr: 'حي العز', nameEn: 'Hay Al-Izz' },
          { id: 'zr-126', nameAr: 'حي التلة', nameEn: 'Hay Al-Talleh' },
          { id: 'zr-127', nameAr: 'شارع الثلاثين', nameEn: 'Thirty St' },
          { id: 'zr-128', nameAr: 'حي الاستقلال', nameEn: 'Hay Al-Istiqlal' },
          { id: 'zr-129', nameAr: 'حي الجبل الاخضر', nameEn: 'Hay Green Mountain' },
          { id: 'zr-130', nameAr: 'حي البشير', nameEn: 'Hay Al-Bashir' },
          { id: 'zr-131', nameAr: 'حي التراث', nameEn: 'Hay Al-Turath' },
          { id: 'zr-132', nameAr: 'حي العقيلة', nameEn: 'Hay Al-Aqeelah' },
          { id: 'zr-133', nameAr: 'حي الجوهرة', nameEn: 'Hay Al-Jawhara' },
          { id: 'zr-134', nameAr: 'حي الملك حسين', nameEn: 'Hay King Hussein' },
          { id: 'zr-135', nameAr: 'حي المعسكر', nameEn: 'Hay Al-Muaskar' },
          { id: 'zr-136', nameAr: 'حي الجسر', nameEn: 'Hay Al-Jisr' },
          { id: 'zr-137', nameAr: 'حي الفتح', nameEn: 'Hay Al-Fath' },
          { id: 'zr-138', nameAr: 'حي الخنساء', nameEn: 'Hay Al-Khansa' },
          { id: 'zr-139', nameAr: 'حي البوادي', nameEn: 'Hay Al-Bawadi' },
          { id: 'zr-140', nameAr: 'حي البحر', nameEn: 'Hay Al-Bahr' },
          { id: 'zr-141', nameAr: 'حي العلا', nameEn: 'Hay Al-Ula' },
          { id: 'zr-142', nameAr: 'حي الاحرار', nameEn: 'Hay Al-Ahrar' },
          { id: 'zr-143', nameAr: 'حي الفجر', nameEn: 'Hay Al-Fajr' },
          { id: 'zr-144', nameAr: 'حي التضامن', nameEn: 'Hay Al-Tadamun' },
          { id: 'zr-145', nameAr: 'حي الميناء', nameEn: 'Hay Al-Mina' },
          { id: 'zr-146', nameAr: 'شارع الوحدة', nameEn: 'Al-Wahdah St' },
          { id: 'zr-147', nameAr: 'حي العروبة', nameEn: 'Hay Al-Oroubah' },
          { id: 'zr-148', nameAr: 'حي المحمدية', nameEn: 'Hay Al-Muhammadiyeh' },
          { id: 'zr-149', nameAr: 'حي البلقاء', nameEn: 'Hay Al-Balqa' },
          { id: 'zr-150', nameAr: 'حي البيادر', nameEn: 'Hay Al-Bayader' },
        ],
      },
      {
        id: 'jo-4', nameAr: 'العقبة', nameEn: 'Aqaba',
        areas: [
          { id: 'aq-1', nameAr: 'وسط العقبة', nameEn: 'Aqaba Downtown' },
          { id: 'aq-2', nameAr: 'الشامية', nameEn: 'Al-Shamiyah' },
          { id: 'aq-3', nameAr: 'المنطقة الاقتصادية', nameEn: 'Economic Zone' },
          { id: 'aq-4', nameAr: 'التاسعة', nameEn: 'Al-Tase\'a' },
          { id: 'aq-5', nameAr: 'الريم', nameEn: 'Al-Reem' },
          { id: 'aq-6', nameAr: 'القويرة', nameEn: 'Al-Quwaira' },
          { id: 'aq-7', nameAr: 'المنارة', nameEn: 'Al-Manarah' },
          { id: 'aq-8', nameAr: 'الرابعة', nameEn: 'Al-Rabi\'a' },
          { id: 'aq-9', nameAr: 'الخامسة', nameEn: 'Al-Khamisa' },
          { id: 'aq-10', nameAr: 'السادسة', nameEn: 'Al-Sadisa' },
          { id: 'aq-11', nameAr: 'السابعة', nameEn: 'Al-Sabi\'a' },
          { id: 'aq-12', nameAr: 'الثامنة', nameEn: 'Al-Thamina' },
          { id: 'aq-13', nameAr: 'العاشرة', nameEn: 'Al-Ashira' },
          { id: 'aq-14', nameAr: 'الميناء', nameEn: 'The Port' },
          { id: 'aq-15', nameAr: 'التجمع الخامس', nameEn: '5th Cluster' },
          { id: 'aq-16', nameAr: 'الحرفيين', nameEn: 'Al-Hirafiyeen' },
          { id: 'aq-17', nameAr: 'المحدود', nameEn: 'Al-Mahdoud' },
          { id: 'aq-18', nameAr: 'السوق التجاري', nameEn: 'Commercial Market' },
          { id: 'aq-19', nameAr: 'الديسة', nameEn: 'Al-Disah' },
          { id: 'aq-20', nameAr: 'وادي رم', nameEn: 'Wadi Rum' },
          { id: 'aq-21', nameAr: 'الاولى', nameEn: 'Al-Oula' },
          { id: 'aq-22', nameAr: 'الثانية', nameEn: 'Al-Thaniya' },
          { id: 'aq-23', nameAr: 'الثالثة', nameEn: 'Al-Thalitha' },
          { id: 'aq-24', nameAr: 'تالا باي', nameEn: 'Tala Bay' },
          { id: 'aq-25', nameAr: 'ايلة', nameEn: 'Ayla' },
          { id: 'aq-26', nameAr: 'السكنية', nameEn: 'Al-Sakaniyeh' },
          { id: 'aq-27', nameAr: 'الصالحية', nameEn: 'Al-Salhiyeh' },
          { id: 'aq-28', nameAr: 'النخيل', nameEn: 'Al-Nakheel' },
          { id: 'aq-29', nameAr: 'حي الامير حمزة', nameEn: 'Hay Al-Amir Hamzah' },
          { id: 'aq-30', nameAr: 'حي الحسين', nameEn: 'Hay Al-Hussein' },
          { id: 'aq-31', nameAr: 'الشلالة', nameEn: 'Al-Shallalah' },
          { id: 'aq-32', nameAr: 'الكورنيش', nameEn: 'Corniche' },
          { id: 'aq-33', nameAr: 'المرسى', nameEn: 'Al-Marsa' },
          { id: 'aq-34', nameAr: 'الراجف', nameEn: 'Al-Rajif' },
          { id: 'aq-35', nameAr: 'ضباعة', nameEn: 'Dhabaa' },
        ],
      },
      {
        id: 'jo-5', nameAr: 'البلقاء', nameEn: 'Balqa',
        areas: [
          { id: 'bl-1', nameAr: 'السلط', nameEn: 'Salt' },
          { id: 'bl-2', nameAr: 'عين الباشا', nameEn: 'Ain Al-Basha' },
          { id: 'bl-3', nameAr: 'الفحيص', nameEn: 'Al-Fuhais' },
          { id: 'bl-4', nameAr: 'ماحص', nameEn: 'Mahis' },
          { id: 'bl-5', nameAr: 'دير علا', nameEn: 'Deir Alla' },
          { id: 'bl-6', nameAr: 'الشونة الجنوبية', nameEn: 'South Shouneh' },
          { id: 'bl-7', nameAr: 'عيرا ويرقا', nameEn: 'Eira wa Yerqa' },
          { id: 'bl-8', nameAr: 'الاغوار الوسطى', nameEn: 'Central Ghors' },
          { id: 'bl-9', nameAr: 'السلالم', nameEn: 'Al-Salalim' },
          { id: 'bl-10', nameAr: 'الميدان', nameEn: 'Al-Maidan' },
          { id: 'bl-11', nameAr: 'العرضة', nameEn: 'Al-Ardah' },
          { id: 'bl-12', nameAr: 'جادا', nameEn: 'Jada' },
          { id: 'bl-13', nameAr: 'الصبيحي', nameEn: 'Al-Subeihi' },
          { id: 'bl-14', nameAr: 'السرو', nameEn: 'Al-Saru' },
          { id: 'bl-15', nameAr: 'كفر هودا', nameEn: 'Kufr Huda' },
          { id: 'bl-16', nameAr: 'الرميمين', nameEn: 'Al-Rumaimin' },
          { id: 'bl-17', nameAr: 'يرقا', nameEn: 'Yerqa' },
          { id: 'bl-18', nameAr: 'الشرب', nameEn: 'Al-Shurb' },
          { id: 'bl-19', nameAr: 'ابو الزيغان', nameEn: 'Abu Al-Zighan' },
          { id: 'bl-20', nameAr: 'علان', nameEn: 'Allan' },
          { id: 'bl-21', nameAr: 'وسط السلط', nameEn: 'Salt Downtown' },
          { id: 'bl-22', nameAr: 'الخندق', nameEn: 'Al-Khandaq' },
          { id: 'bl-23', nameAr: 'الجدعة', nameEn: 'Al-Jadaa' },
          { id: 'bl-24', nameAr: 'عيرا', nameEn: 'Eira' },
          { id: 'bl-25', nameAr: 'السلالم الغربية', nameEn: 'West Salalim' },
          { id: 'bl-26', nameAr: 'زي', nameEn: 'Zai' },
          { id: 'bl-27', nameAr: 'يرقا العليا', nameEn: 'Upper Yerqa' },
          { id: 'bl-28', nameAr: 'صبحا', nameEn: 'Sabha' },
          { id: 'bl-29', nameAr: 'سوف', nameEn: 'Souf' },
          { id: 'bl-30', nameAr: 'الحمر', nameEn: 'Al-Hummar' },
          { id: 'bl-31', nameAr: 'ابو نصير', nameEn: 'Abu Nsair' },
          { id: 'bl-32', nameAr: 'جلعاد', nameEn: 'Gilead' },
          { id: 'bl-33', nameAr: 'الميدان الجنوبي', nameEn: 'South Maidan' },
          { id: 'bl-34', nameAr: 'كفر هودا الجنوبية', nameEn: 'South Kufr Huda' },
          { id: 'bl-35', nameAr: 'الصبيحي الشمالي', nameEn: 'North Subeihi' },
        ],
      },
      {
        id: 'jo-6', nameAr: 'المفرق', nameEn: 'Mafraq',
        areas: [
          { id: 'mf-1', nameAr: 'وسط المفرق', nameEn: 'Mafraq Downtown' },
          { id: 'mf-2', nameAr: 'الخالدية', nameEn: 'Al-Khaldieh' },
          { id: 'mf-3', nameAr: 'البادية الشمالية', nameEn: 'Northern Badia' },
          { id: 'mf-4', nameAr: 'الصفاوي', nameEn: 'Al-Safawi' },
          { id: 'mf-5', nameAr: 'الرويشد', nameEn: 'Al-Ruwaished' },
          { id: 'mf-6', nameAr: 'حوشا', nameEn: 'Hawsha' },
          { id: 'mf-7', nameAr: 'ام الجمال', nameEn: 'Um Al-Jimal' },
          { id: 'mf-8', nameAr: 'المنشية', nameEn: 'Al-Manshiyeh' },
          { id: 'mf-9', nameAr: 'بلعما', nameEn: 'Bal\'ama' },
          { id: 'mf-10', nameAr: 'ايدون', nameEn: 'Aidoun' },
          { id: 'mf-11', nameAr: 'الحمراء', nameEn: 'Al-Hamra' },
          { id: 'mf-12', nameAr: 'رحاب', nameEn: 'Rehab' },
          { id: 'mf-13', nameAr: 'الزعتري', nameEn: 'Al-Zaatari' },
          { id: 'mf-14', nameAr: 'سما السرحان', nameEn: 'Sama Al-Sarhan' },
          { id: 'mf-15', nameAr: 'ام القطين', nameEn: 'Um Al-Quttain' },
          { id: 'mf-16', nameAr: 'الباعج', nameEn: 'Al-Baaj' },
          { id: 'mf-17', nameAr: 'جامعة ال البيت', nameEn: 'Al Al-Bayt University' },
          { id: 'mf-18', nameAr: 'دير الكهف', nameEn: 'Deir Al-Kahf' },
          { id: 'mf-19', nameAr: 'معان', nameEn: 'Maen' },
          { id: 'mf-20', nameAr: 'سال', nameEn: 'Sal' },
          { id: 'mf-21', nameAr: 'ارحاب', nameEn: 'Irhab' },
          { id: 'mf-22', nameAr: 'الدجنية', nameEn: 'Al-Dajniyeh' },
          { id: 'mf-23', nameAr: 'علعال', nameEn: 'Alal' },
          { id: 'mf-24', nameAr: 'الزنية', nameEn: 'Al-Zaniyeh' },
          { id: 'mf-25', nameAr: 'البويضة', nameEn: 'Al-Buwaidah' },
          { id: 'mf-26', nameAr: 'مغير السرحان', nameEn: 'Mughayer Al-Sarhan' },
          { id: 'mf-27', nameAr: 'نادرة', nameEn: 'Nadirah' },
          { id: 'mf-28', nameAr: 'حيان المشرف', nameEn: 'Hayyan Al-Mushrif' },
          { id: 'mf-29', nameAr: 'الحصن', nameEn: 'Al-Husn' },
          { id: 'mf-30', nameAr: 'العمرية', nameEn: 'Al-Omriyeh' },
          { id: 'mf-31', nameAr: 'طيب اسم', nameEn: 'Tayyib Ism' },
          { id: 'mf-32', nameAr: 'قميم', nameEn: 'Qumaim' },
          { id: 'mf-33', nameAr: 'ذنيبة', nameEn: 'Dhunayba' },
          { id: 'mf-34', nameAr: 'ام السرب', nameEn: 'Um Al-Surab' },
          { id: 'mf-35', nameAr: 'المكيفتة', nameEn: 'Al-Mukaifteh' },
          { id: 'mf-36', nameAr: 'حوفا الغربية', nameEn: 'Hawfa Al-Gharbiyeh' },
          { id: 'mf-37', nameAr: 'خربة السمراء', nameEn: 'Khirbet Al-Samra' },
          { id: 'mf-38', nameAr: 'الهاشمية', nameEn: 'Al-Hashimiyeh' },
          { id: 'mf-39', nameAr: 'ام الوليد', nameEn: 'Um Al-Waleed' },
          { id: 'mf-40', nameAr: 'الخربة السمراء الشمالية', nameEn: 'North Khirbet Al-Samra' },
          { id: 'mf-41', nameAr: 'السرو', nameEn: 'Al-Sarw' },
          { id: 'mf-42', nameAr: 'الحلابات', nameEn: 'Al-Hallabat' },
          { id: 'mf-43', nameAr: 'ام الجمال الشرقية', nameEn: 'Um Al-Jimal East' },
          { id: 'mf-44', nameAr: 'الخالدية الشمالية', nameEn: 'Al-Khaldieh North' },
          { id: 'mf-45', nameAr: 'ام النعام', nameEn: 'Um Al-Naam' },
          { id: 'mf-46', nameAr: 'جابر', nameEn: 'Jaber' },
          { id: 'mf-47', nameAr: 'المنصورة', nameEn: 'Al-Mansoura' },
          { id: 'mf-48', nameAr: 'روضة الامير راشد', nameEn: 'Rawdat Al-Amir Rashid' },
          { id: 'mf-49', nameAr: 'ام بطمة', nameEn: 'Um Batmah' },
          { id: 'mf-50', nameAr: 'الحمراوات', nameEn: 'Al-Hamrawat' },
          { id: 'mf-51', nameAr: 'خربة ظهرة', nameEn: 'Khirbet Dhahrah' },
          { id: 'mf-52', nameAr: 'المقاط', nameEn: 'Al-Maqat' },
          { id: 'mf-53', nameAr: 'الحويه', nameEn: 'Al-Hawiyah' },
          { id: 'mf-54', nameAr: 'عين الحمام', nameEn: 'Ain Al-Hammam' },
          { id: 'mf-55', nameAr: 'الناصرية', nameEn: 'Al-Nasriyeh' },
          { id: 'mf-56', nameAr: 'الحكمة', nameEn: 'Al-Hikmah' },
          { id: 'mf-57', nameAr: 'خو', nameEn: 'Khaw' },
          { id: 'mf-58', nameAr: 'ام الرصاص', nameEn: 'Um Al-Rasas' },
          { id: 'mf-59', nameAr: 'السعيدية', nameEn: 'Al-Saeediyeh' },
          { id: 'mf-60', nameAr: 'ام اللولو', nameEn: 'Um Al-Lulu' },
          { id: 'mf-61', nameAr: 'المشيرفة', nameEn: 'Al-Mushayrifeh' },
          { id: 'mf-62', nameAr: 'دير القن', nameEn: 'Deir Al-Qinn' },
          { id: 'mf-63', nameAr: 'مكيفتة الجنوبية', nameEn: 'Mukaifteh South' },
          { id: 'mf-64', nameAr: 'زملة الامير غازي', nameEn: 'Zamlat Al-Amir Ghazi' },
          { id: 'mf-65', nameAr: 'الخالدية الجنوبية', nameEn: 'Al-Khaldieh South' },
          { id: 'mf-66', nameAr: 'الخالدية الغربية', nameEn: 'Al-Khaldieh West' },
          { id: 'mf-67', nameAr: 'تل الخالدية', nameEn: 'Tal Al-Khaldieh' },
          { id: 'mf-68', nameAr: 'خربة الخالدية', nameEn: 'Khirbet Al-Khaldieh' },
          { id: 'mf-69', nameAr: 'حي الخالدية الشرقي', nameEn: 'Khaldieh East Quarter' },
          { id: 'mf-70', nameAr: 'سما السرحان الغربية', nameEn: 'Sama Al-Sarhan West' },
          { id: 'mf-71', nameAr: 'سما السرحان الشرقية', nameEn: 'Sama Al-Sarhan East' },
          { id: 'mf-72', nameAr: 'مغير السرحان الشمالي', nameEn: 'Mughayer Al-Sarhan North' },
          { id: 'mf-73', nameAr: 'مغير السرحان الجنوبي', nameEn: 'Mughayer Al-Sarhan South' },
          { id: 'mf-74', nameAr: 'زملة السرحان', nameEn: 'Zamlat Al-Sarhan' },
          { id: 'mf-75', nameAr: 'تل السرحان', nameEn: 'Tal Al-Sarhan' },
          { id: 'mf-76', nameAr: 'رحاب الشمالية', nameEn: 'Rehab North' },
          { id: 'mf-77', nameAr: 'رحاب الجنوبية', nameEn: 'Rehab South' },
          { id: 'mf-78', nameAr: 'رحاب الغربية', nameEn: 'Rehab West' },
          { id: 'mf-79', nameAr: 'تل رحاب', nameEn: 'Tal Rehab' },
          { id: 'mf-80', nameAr: 'خربة رحاب', nameEn: 'Khirbet Rehab' },
          { id: 'mf-81', nameAr: 'البستانة', nameEn: 'Al-Bustanah' },
          { id: 'mf-82', nameAr: 'ام السويت', nameEn: 'Um Al-Suwayt' },
          { id: 'mf-83', nameAr: 'الدغيلات', nameEn: 'Al-Dughaylat' },
          { id: 'mf-84', nameAr: 'الزبيرية', nameEn: 'Al-Zubayriyeh' },
        ],
      },
      {
        id: 'jo-7', nameAr: 'الكرك', nameEn: 'Karak',
        areas: [
          { id: 'kr-1', nameAr: 'وسط الكرك', nameEn: 'Karak Downtown' },
          { id: 'kr-2', nameAr: 'المزار الجنوبي', nameEn: 'Al-Mazar Al-Janoubi' },
          { id: 'kr-3', nameAr: 'القصر', nameEn: 'Al-Qasr' },
          { id: 'kr-4', nameAr: 'مؤتة', nameEn: 'Mu\'tah' },
          { id: 'kr-5', nameAr: 'غور الصافي', nameEn: 'Ghor Al-Safi' },
          { id: 'kr-6', nameAr: 'فقوع', nameEn: 'Faqou' },
          { id: 'kr-7', nameAr: 'عي', nameEn: 'Ay' },
          { id: 'kr-8', nameAr: 'الربة', nameEn: 'Al-Rabbah' },
          { id: 'kr-9', nameAr: 'الثنية', nameEn: 'Al-Thaniyyeh' },
          { id: 'kr-10', nameAr: 'الادنانية', nameEn: 'Al-Adnaniyeh' },
          { id: 'kr-11', nameAr: 'المنشية', nameEn: 'Al-Manshiyeh' },
          { id: 'kr-12', nameAr: 'ذات راس', nameEn: 'That Ras' },
          { id: 'kr-13', nameAr: 'سماكية', nameEn: 'Smakiyyeh' },
          { id: 'kr-14', nameAr: 'الوسية', nameEn: 'Al-Wasiyyeh' },
          { id: 'kr-15', nameAr: 'خنزيرة', nameEn: 'Khanzirah' },
          { id: 'kr-16', nameAr: 'جامعة مؤتة', nameEn: 'Mu\'tah University' },
          { id: 'kr-17', nameAr: 'عدنان', nameEn: 'Adnan' },
          { id: 'kr-18', nameAr: 'القطرانة', nameEn: 'Al-Qatraneh' },
          { id: 'kr-19', nameAr: 'الشهابية', nameEn: 'Al-Shahabiyeh' },
          { id: 'kr-20', nameAr: 'كثربا', nameEn: 'Kathraba' },
          { id: 'kr-21', nameAr: 'زحوم', nameEn: 'Zahoom' },
          { id: 'kr-22', nameAr: 'الحمود', nameEn: 'Al-Hamoud' },
          { id: 'kr-23', nameAr: 'مسار', nameEn: 'Masar' },
          { id: 'kr-24', nameAr: 'الجديدة', nameEn: 'Al-Jadeedah' },
          { id: 'kr-25', nameAr: 'بتير', nameEn: 'Batir' },
          { id: 'kr-26', nameAr: 'المرج', nameEn: 'Al-Marj' },
          { id: 'kr-27', nameAr: 'العراق', nameEn: 'Al-Iraq' },
          { id: 'kr-28', nameAr: 'الميسرة', nameEn: 'Al-Maysarah' },
          { id: 'kr-29', nameAr: 'عين اللبن', nameEn: 'Ain Al-Laban' },
          { id: 'kr-30', nameAr: 'مؤاب', nameEn: 'Moab' },
          { id: 'kr-31', nameAr: 'خربة ازمينة', nameEn: 'Khirbet Izminah' },
          { id: 'kr-32', nameAr: 'الحسينية', nameEn: 'Al-Husayniyeh' },
          { id: 'kr-33', nameAr: 'الصرفة', nameEn: 'Al-Sarfah' },
          { id: 'kr-34', nameAr: 'المشيرفة', nameEn: 'Al-Mushayrifeh' },
          { id: 'kr-35', nameAr: 'غور المزرعة', nameEn: 'Ghor Al-Mazra' },
        ],
      },
      {
        id: 'jo-8', nameAr: 'جرش', nameEn: 'Jerash',
        areas: [
          { id: 'jr-1', nameAr: 'وسط جرش', nameEn: 'Jerash Downtown' },
          { id: 'jr-2', nameAr: 'سوف', nameEn: 'Souf' },
          { id: 'jr-3', nameAr: 'المصطبة', nameEn: 'Al-Mastabah' },
          { id: 'jr-4', nameAr: 'برما', nameEn: 'Burma' },
          { id: 'jr-5', nameAr: 'ساكب', nameEn: 'Sakeb' },
          { id: 'jr-6', nameAr: 'الكتة', nameEn: 'Al-Kittah' },
          { id: 'jr-7', nameAr: 'قفقفا', nameEn: 'Qafqafa' },
          { id: 'jr-8', nameAr: 'نحلة', nameEn: 'Nahleh' },
          { id: 'jr-9', nameAr: 'بليلا', nameEn: 'Bleila' },
          { id: 'jr-10', nameAr: 'الجبارات', nameEn: 'Al-Jabbarat' },
          { id: 'jr-11', nameAr: 'ريمون', nameEn: 'Raimoun' },
          { id: 'jr-12', nameAr: 'كفر خل', nameEn: 'Kufr Khall' },
          { id: 'jr-13', nameAr: 'ثغرة عصفور', nameEn: 'Thagret Asfour' },
          { id: 'jr-14', nameAr: 'دبين', nameEn: 'Dibeen' },
          { id: 'jr-15', nameAr: 'المرصع', nameEn: 'Al-Marsa' },
          { id: 'jr-16', nameAr: 'الاثار', nameEn: 'Archaeological Site' },
          { id: 'jr-17', nameAr: 'حدادة', nameEn: 'Haddadah' },
          { id: 'jr-18', nameAr: 'جبارات ساكب', nameEn: 'Jabbarat Sakeb' },
          { id: 'jr-19', nameAr: 'المجدل', nameEn: 'Al-Majdal' },
          { id: 'jr-20', nameAr: 'الكفير', nameEn: 'Al-Kufair' },
          { id: 'jr-21', nameAr: 'عنيبة', nameEn: 'Unaybah' },
          { id: 'jr-22', nameAr: 'جبا', nameEn: 'Jaba' },
          { id: 'jr-23', nameAr: 'الحدادة', nameEn: 'Al-Haddadah' },
          { id: 'jr-24', nameAr: 'طاحونة', nameEn: 'Tahouna' },
          { id: 'jr-25', nameAr: 'بركتين', nameEn: 'Birkatein' },
          { id: 'jr-26', nameAr: 'دير اللياث', nameEn: 'Deir Al-Liyath' },
          { id: 'jr-27', nameAr: 'كفر خل الشمالية', nameEn: 'North Kufr Khall' },
          { id: 'jr-28', nameAr: 'نبع السردين', nameEn: 'Nab Al-Sardeen' },
          { id: 'jr-29', nameAr: 'غابة دبين', nameEn: 'Dibeen Forest' },
          { id: 'jr-30', nameAr: 'عين القيروان', nameEn: 'Ain Al-Qairawan' },
        ],
      },
      {
        id: 'jo-9', nameAr: 'عجلون', nameEn: 'Ajloun',
        areas: [
          { id: 'aj-1', nameAr: 'وسط عجلون', nameEn: 'Ajloun Downtown' },
          { id: 'aj-2', nameAr: 'كفرنجة', nameEn: 'Kufranjah' },
          { id: 'aj-3', nameAr: 'عنجرة', nameEn: 'Anjarah' },
          { id: 'aj-4', nameAr: 'صخرة', nameEn: 'Sakhra' },
          { id: 'aj-5', nameAr: 'عبين', nameEn: 'Ibbin' },
          { id: 'aj-6', nameAr: 'عرجان', nameEn: 'Arjan' },
          { id: 'aj-7', nameAr: 'راسون', nameEn: 'Rasoun' },
          { id: 'aj-8', nameAr: 'عين جنا', nameEn: 'Ain Janna' },
          { id: 'aj-9', nameAr: 'اشتفينا', nameEn: 'Ishtafina' },
          { id: 'aj-10', nameAr: 'حلاوة', nameEn: 'Halawah' },
          { id: 'aj-11', nameAr: 'عبلين', nameEn: 'Ibleen' },
          { id: 'aj-12', nameAr: 'باعون', nameEn: 'Baoun' },
          { id: 'aj-13', nameAr: 'اوصرة', nameEn: 'Awsirah' },
          { id: 'aj-14', nameAr: 'قلعة عجلون', nameEn: 'Ajloun Castle' },
          { id: 'aj-15', nameAr: 'محمية عجلون', nameEn: 'Ajloun Reserve' },
          { id: 'aj-16', nameAr: 'القلعة', nameEn: 'Al-Qal\'ah' },
          { id: 'aj-17', nameAr: 'زقلاب', nameEn: 'Zuqlab' },
          { id: 'aj-18', nameAr: 'راجب', nameEn: 'Rajeb' },
          { id: 'aj-19', nameAr: 'محنا', nameEn: 'Mahna' },
          { id: 'aj-20', nameAr: 'عفنة', nameEn: 'Afneh' },
          { id: 'aj-21', nameAr: 'دير الحصن', nameEn: 'Deir Al-Husn' },
          { id: 'aj-22', nameAr: 'صنعار', nameEn: 'Sanaar' },
          { id: 'aj-23', nameAr: 'ام الينابيع', nameEn: 'Um Al-Yanabi' },
          { id: 'aj-24', nameAr: 'قلعة الربض', nameEn: 'Qalaat Al-Rabad' },
          { id: 'aj-25', nameAr: 'الوهادنة', nameEn: 'Al-Wahadneh' },
          { id: 'aj-26', nameAr: 'المجدل', nameEn: 'Al-Majdal' },
          { id: 'aj-27', nameAr: 'خربة الوهادنة', nameEn: 'Khirbet Al-Wahadneh' },
          { id: 'aj-28', nameAr: 'جنين الصفا', nameEn: 'Jenin Al-Safa' },
          { id: 'aj-29', nameAr: 'ساكب', nameEn: 'Sakeb' },
          { id: 'aj-30', nameAr: 'عوصرة', nameEn: 'Awsirah' },
        ],
      },
      {
        id: 'jo-10', nameAr: 'مادبا', nameEn: 'Madaba',
        areas: [
          { id: 'md-1', nameAr: 'وسط مادبا', nameEn: 'Madaba Downtown' },
          { id: 'md-2', nameAr: 'ذيبان', nameEn: 'Dhiban' },
          { id: 'md-3', nameAr: 'الفيصلية', nameEn: 'Al-Faisaliyeh' },
          { id: 'md-4', nameAr: 'ملكاوي', nameEn: 'Malkawi' },
          { id: 'md-5', nameAr: 'لب', nameEn: 'Lib' },
          { id: 'md-6', nameAr: 'حسبان', nameEn: 'Hesban' },
          { id: 'md-7', nameAr: 'جبل نيبو', nameEn: 'Mount Nebo' },
          { id: 'md-8', nameAr: 'معين', nameEn: 'Ma\'in' },
          { id: 'md-9', nameAr: 'ام الرصاص', nameEn: 'Um Al-Rasas' },
          { id: 'md-10', nameAr: 'ماعين', nameEn: 'Ma\'in Springs' },
          { id: 'md-11', nameAr: 'الخطابية', nameEn: 'Al-Khattabiyeh' },
          { id: 'md-12', nameAr: 'المشنقة', nameEn: 'Al-Mashnaqah' },
          { id: 'md-13', nameAr: 'حنينا', nameEn: 'Hanina' },
          { id: 'md-14', nameAr: 'جرينة', nameEn: 'Jreinah' },
          { id: 'md-15', nameAr: 'ملعب مادبا', nameEn: 'Madaba Stadium' },
          { id: 'md-16', nameAr: 'خريطة الفسيفساء', nameEn: 'Mosaic Map' },
          { id: 'md-17', nameAr: 'ام العمد', nameEn: 'Um Al-Amad' },
          { id: 'md-18', nameAr: 'عطروز', nameEn: 'Atruz' },
          { id: 'md-19', nameAr: 'الولية', nameEn: 'Al-Waliyeh' },
          { id: 'md-20', nameAr: 'مليح', nameEn: 'Mleih' },
          { id: 'md-21', nameAr: 'ماكور', nameEn: 'Makour' },
          { id: 'md-22', nameAr: 'الفيحاء', nameEn: 'Al-Fayha' },
          { id: 'md-23', nameAr: 'نطفة', nameEn: 'Natfeh' },
          { id: 'md-24', nameAr: 'ذيبان الشمالية', nameEn: 'North Dhiban' },
          { id: 'md-25', nameAr: 'ذيبان الجنوبية', nameEn: 'South Dhiban' },
          { id: 'md-26', nameAr: 'جبل نيبو الغربي', nameEn: 'West Mount Nebo' },
          { id: 'md-27', nameAr: 'الحمامات', nameEn: 'Al-Hammamat' },
          { id: 'md-28', nameAr: 'العالوك', nameEn: 'Al-Alouk' },
        ],
      },
      {
        id: 'jo-11', nameAr: 'معان', nameEn: 'Maan',
        areas: [
          { id: 'mn-1', nameAr: 'وسط معان', nameEn: 'Maan Downtown' },
          { id: 'mn-2', nameAr: 'الشوبك', nameEn: 'Al-Shobak' },
          { id: 'mn-3', nameAr: 'الحسينية', nameEn: 'Al-Husainiyeh' },
          { id: 'mn-4', nameAr: 'وادي عربة', nameEn: 'Wadi Araba' },
          { id: 'mn-5', nameAr: 'البتراء', nameEn: 'Petra' },
          { id: 'mn-6', nameAr: 'الطيبة', nameEn: 'Al-Taybeh' },
          { id: 'mn-7', nameAr: 'ايل', nameEn: 'Eil' },
          { id: 'mn-8', nameAr: 'الجفر', nameEn: 'Al-Jafr' },
          { id: 'mn-9', nameAr: 'وادي موسى', nameEn: 'Wadi Musa' },
          { id: 'mn-10', nameAr: 'اذرح', nameEn: 'Udhruh' },
          { id: 'mn-11', nameAr: 'الحسا', nameEn: 'Al-Hasa' },
          { id: 'mn-12', nameAr: 'المريغة', nameEn: 'Al-Mreigha' },
          { id: 'mn-13', nameAr: 'اطرب', nameEn: 'Atrub' },
          { id: 'mn-14', nameAr: 'نقب', nameEn: 'Naqab' },
          { id: 'mn-15', nameAr: 'بسطة', nameEn: 'Basta' },
          { id: 'mn-16', nameAr: 'الراجف', nameEn: 'Al-Rajif' },
          { id: 'mn-17', nameAr: 'صدقة', nameEn: 'Sadaqah' },
          { id: 'mn-18', nameAr: 'العقرباء', nameEn: 'Al-Aqrabaa' },
          { id: 'mn-19', nameAr: 'نقب عقبة', nameEn: 'Naqab Aqabah' },
          { id: 'mn-20', nameAr: 'معان الحمراء', nameEn: 'Maan Al-Hamra' },
          { id: 'mn-21', nameAr: 'معان الشامية', nameEn: 'Maan Al-Shamiyeh' },
          { id: 'mn-22', nameAr: 'حي الحسين', nameEn: 'Hay Al-Hussein' },
          { id: 'mn-23', nameAr: 'جامعة الحسين', nameEn: 'Al-Hussein University' },
          { id: 'mn-24', nameAr: 'الكنيسة', nameEn: 'Al-Kaneesah' },
          { id: 'mn-25', nameAr: 'عين البيضاء', nameEn: 'Ain Al-Bayda' },
          { id: 'mn-26', nameAr: 'الشوبك القديمة', nameEn: 'Old Shobak' },
          { id: 'mn-27', nameAr: 'قلعة الشوبك', nameEn: 'Shobak Castle' },
          { id: 'mn-28', nameAr: 'نقب عين', nameEn: 'Naqab Ain' },
        ],
      },
      {
        id: 'jo-12', nameAr: 'الطفيلة', nameEn: 'Tafilah',
        areas: [
          { id: 'tf-1', nameAr: 'وسط الطفيلة', nameEn: 'Tafilah Downtown' },
          { id: 'tf-2', nameAr: 'بصيرا', nameEn: 'Buseira' },
          { id: 'tf-3', nameAr: 'الحسا', nameEn: 'Al-Hasa' },
          { id: 'tf-4', nameAr: 'ضانا', nameEn: 'Dana' },
          { id: 'tf-5', nameAr: 'القادسية', nameEn: 'Al-Qadisiyeh' },
          { id: 'tf-6', nameAr: 'عيمة', nameEn: 'Aima' },
          { id: 'tf-7', nameAr: 'جرف الدراويش', nameEn: 'Jurf Al-Darawish' },
          { id: 'tf-8', nameAr: 'غرندل', nameEn: 'Gharandal' },
          { id: 'tf-9', nameAr: 'العيص', nameEn: 'Al-Ais' },
          { id: 'tf-10', nameAr: 'محمية ضانا', nameEn: 'Dana Reserve' },
          { id: 'tf-11', nameAr: 'سلع', nameEn: 'Sala' },
          { id: 'tf-12', nameAr: 'لعبن', nameEn: 'La\'ban' },
          { id: 'tf-13', nameAr: 'جامعة الطفيلة', nameEn: 'Tafila University' },
          { id: 'tf-14', nameAr: 'الحمرا', nameEn: 'Al-Hamra' },
          { id: 'tf-15', nameAr: 'سلع الغربية', nameEn: 'West Sala' },
          { id: 'tf-16', nameAr: 'الصدقة', nameEn: 'Al-Sadaqah' },
          { id: 'tf-17', nameAr: 'ارينبة', nameEn: 'Arinbah' },
          { id: 'tf-18', nameAr: 'الرشادية', nameEn: 'Al-Rashadeyyeh' },
          { id: 'tf-19', nameAr: 'بصيرا الجنوبية', nameEn: 'South Buseira' },
          { id: 'tf-20', nameAr: 'عيمة الشمالية', nameEn: 'North Aima' },
          { id: 'tf-21', nameAr: 'وادي فينان', nameEn: 'Wadi Feynan' },
          { id: 'tf-22', nameAr: 'حي الجامعة', nameEn: 'University Quarter' },
        ],
      },
      {
        id: 'jo-13', nameAr: 'الاغوار الشمالية', nameEn: 'Northern Jordan Valley',
        areas: [
          { id: 'gvn-1', nameAr: 'الشونة الشمالية', nameEn: 'North Shouneh' },
          { id: 'gvn-2', nameAr: 'المشارع', nameEn: 'Al-Mashare' },
          { id: 'gvn-3', nameAr: 'وادي الريان', nameEn: 'Wadi Al-Rayyan' },
          { id: 'gvn-4', nameAr: 'المنشية', nameEn: 'Al-Manshiyeh' },
          { id: 'gvn-5', nameAr: 'كريمة', nameEn: 'Kreimeh' },
          { id: 'gvn-6', nameAr: 'العدسية', nameEn: 'Al-Adasiyeh' },
          { id: 'gvn-7', nameAr: 'الطيبة', nameEn: 'Al-Taybeh' },
          { id: 'gvn-8', nameAr: 'المرصع', nameEn: 'Al-Marsa' },
          { id: 'gvn-9', nameAr: 'وقاص', nameEn: 'Waqqas' },
          { id: 'gvn-10', nameAr: 'ابو سيدو', nameEn: 'Abu Seedo' },
          { id: 'gvn-11', nameAr: 'شيخ حسين', nameEn: 'Sheikh Hussein' },
          { id: 'gvn-12', nameAr: 'المغير', nameEn: 'Al-Mughayer' },
          { id: 'gvn-13', nameAr: 'البويضة', nameEn: 'Al-Bweida' },
          { id: 'gvn-14', nameAr: 'كفر ابيل', nameEn: 'Kufr Abeel' },
          { id: 'gvn-15', nameAr: 'ابو القين', nameEn: 'Abu Al-Qein' },
          { id: 'gvn-16', nameAr: 'تل الاربعين', nameEn: 'Tal Al-Arbain' },
          { id: 'gvn-17', nameAr: 'الباقورة', nameEn: 'Al-Baqoura' },
          { id: 'gvn-18', nameAr: 'المعمورة', nameEn: 'Al-Mamurah' },
          { id: 'gvn-19', nameAr: 'زور ابو الخنزير', nameEn: 'Zor Abu Al-Khinzir' },
          { id: 'gvn-20', nameAr: 'ابو هابيل', nameEn: 'Abu Habil' },
          { id: 'gvn-21', nameAr: 'تل المنطار', nameEn: 'Tal Al-Mantar' },
          { id: 'gvn-22', nameAr: 'الحمة الاردنية', nameEn: 'Jordanian Hamma' },
          { id: 'gvn-23', nameAr: 'طبقة فحل', nameEn: 'Tabaqat Fahl' },
          { id: 'gvn-24', nameAr: 'يابس', nameEn: 'Yabes' },
        ],
      },
      {
        id: 'jo-15', nameAr: 'الاغوار الوسطى', nameEn: 'Central Jordan Valley',
        areas: [
          { id: 'gvc-1', nameAr: 'دير علا', nameEn: 'Deir Alla' },
          { id: 'gvc-2', nameAr: 'الكرامة', nameEn: 'Al-Karameh' },
          { id: 'gvc-3', nameAr: 'الشونة الوسطى', nameEn: 'Central Shouneh' },
          { id: 'gvc-4', nameAr: 'المعادي', nameEn: 'Al-Maadi' },
          { id: 'gvc-5', nameAr: 'يبلا', nameEn: 'Yabla' },
          { id: 'gvc-6', nameAr: 'الجسر', nameEn: 'Al-Jisr' },
          { id: 'gvc-7', nameAr: 'الكفرين', nameEn: 'Al-Kafrein' },
          { id: 'gvc-8', nameAr: 'تل الرمان', nameEn: 'Tal Al-Rumman' },
          { id: 'gvc-9', nameAr: 'ابو زيغان', nameEn: 'Abu Zighan' },
          { id: 'gvc-10', nameAr: 'الروضة', nameEn: 'Al-Rawdah' },
          { id: 'gvc-11', nameAr: 'ابو عبيلة', nameEn: 'Abu Obailah' },
          { id: 'gvc-12', nameAr: 'المشارع', nameEn: 'Al-Mashare' },
          { id: 'gvc-13', nameAr: 'الجويدة', nameEn: 'Al-Juwaydah' },
          { id: 'gvc-14', nameAr: 'ابو الزيغان الشمالي', nameEn: 'Abu Zighan North' },
          { id: 'gvc-15', nameAr: 'الزميلة', nameEn: 'Al-Zumaylah' },
          { id: 'gvc-16', nameAr: 'تل المنطار', nameEn: 'Tal Al-Mantar' },
          { id: 'gvc-17', nameAr: 'الحمة', nameEn: 'Al-Hammah' },
          { id: 'gvc-18', nameAr: 'معدي', nameEn: 'Maadi' },
          { id: 'gvc-19', nameAr: 'البقعة', nameEn: 'Al-Buqaia' },
          { id: 'gvc-20', nameAr: 'ام حماد', nameEn: 'Um Hammad' },
          { id: 'gvc-21', nameAr: 'الصوالحة', nameEn: 'Al-Sawalhah' },
          { id: 'gvc-22', nameAr: 'العارضة', nameEn: 'Al-Aridah' },
          { id: 'gvc-23', nameAr: 'النويعمة', nameEn: 'Al-Nuwaymah' },
          { id: 'gvc-24', nameAr: 'القرين', nameEn: 'Al-Qurain' },
          { id: 'gvc-25', nameAr: 'الضراغمة', nameEn: 'Al-Daraghmah' },
        ],
      },
      {
        id: 'jo-16', nameAr: 'الاغوار الجنوبية', nameEn: 'Southern Jordan Valley',
        areas: [
          { id: 'gvs-1', nameAr: 'غور الصافي', nameEn: 'Ghor Al-Safi' },
          { id: 'gvs-2', nameAr: 'غور المزرعة', nameEn: 'Ghor Al-Mazra\'a' },
          { id: 'gvs-3', nameAr: 'غور الحديثة', nameEn: 'Ghor Al-Haditha' },
          { id: 'gvs-4', nameAr: 'فيفا', nameEn: 'FIFA' },
          { id: 'gvs-5', nameAr: 'الشونة الجنوبية', nameEn: 'South Shouneh' },
          { id: 'gvs-6', nameAr: 'غور نمرين', nameEn: 'Ghor Nimrin' },
          { id: 'gvs-7', nameAr: 'البحر الميت', nameEn: 'Dead Sea' },
          { id: 'gvs-8', nameAr: 'الراما', nameEn: 'Al-Rama' },
          { id: 'gvs-9', nameAr: 'غور الذراع', nameEn: 'Ghor Al-Dhira' },
          { id: 'gvs-10', nameAr: 'الخنازير', nameEn: 'Al-Khanazeer' },
          { id: 'gvs-11', nameAr: 'غور فيفا', nameEn: 'Ghor FIFA' },
          { id: 'gvs-12', nameAr: 'خربة الحزيز', nameEn: 'Khirbet Al-Haziz' },
          { id: 'gvs-13', nameAr: 'السلطاني', nameEn: 'Al-Sultani' },
          { id: 'gvs-14', nameAr: 'مزرعة الاطفائية', nameEn: 'Mazraat Al-Itfaiyeh' },
        ],
      },
      {
        id: 'jo-14', nameAr: 'الازرق', nameEn: 'Azraq',
        areas: [
          { id: 'az-1', nameAr: 'الازرق الشمالي', nameEn: 'North Azraq' },
          { id: 'az-2', nameAr: 'الازرق الجنوبي', nameEn: 'South Azraq' },
          { id: 'az-3', nameAr: 'محمية الازرق', nameEn: 'Azraq Reserve' },
          { id: 'az-4', nameAr: 'قصر عمرة', nameEn: 'Qusayr Amra' },
          { id: 'az-5', nameAr: 'قصر الحرانة', nameEn: 'Qasr Al-Harranah' },
          { id: 'az-6', nameAr: 'قصر الازرق', nameEn: 'Azraq Castle' },
          { id: 'az-7', nameAr: 'الازرق الصناعية', nameEn: 'Azraq Industrial' },
          { id: 'az-8', nameAr: 'ام القطين', nameEn: 'Um Al-Quttain' },
          { id: 'az-9', nameAr: 'عين الزرقا', nameEn: 'Ain Al-Zarqa' },
          { id: 'az-10', nameAr: 'قصر الاسيخم', nameEn: 'Qasr Al-Usaykhim' },
          { id: 'az-11', nameAr: 'الحمرانية', nameEn: 'Al-Hamraniyeh' },
          { id: 'az-12', nameAr: 'الازرق الاوسط', nameEn: 'Central Azraq' },
        ],
      },
      {
        id: 'jo-17', nameAr: 'قرى اربد', nameEn: 'Irbid Villages',
        areas: [
          // === لواء الكورة ===
          { id: 'qir-1', nameAr: 'دير ابي سعيد', nameEn: 'Deir Abi Saeed' },
          { id: 'qir-2', nameAr: 'كفر الماء', nameEn: 'Kufr Al-Ma' },
          { id: 'qir-3', nameAr: 'كفر راكب', nameEn: 'Kufr Rakeb' },
          { id: 'qir-4', nameAr: 'كفر عوان', nameEn: 'Kufr Awan' },
          { id: 'qir-5', nameAr: 'كفر يوبا', nameEn: 'Kufr Yuba' },
          { id: 'qir-6', nameAr: 'جديتا', nameEn: 'Jdeita' },
          { id: 'qir-7', nameAr: 'تبنة', nameEn: 'Tibneh' },
          { id: 'qir-8', nameAr: 'دير يوسف', nameEn: 'Deir Yusuf' },
          { id: 'qir-9', nameAr: 'بيت ايدس', nameEn: 'Beit Ides' },
          { id: 'qir-10', nameAr: 'كفر ابيل', nameEn: 'Kufr Abeel' },
          { id: 'qir-11', nameAr: 'جفين', nameEn: 'Jiffin' },
          { id: 'qir-12', nameAr: 'دوقرة', nameEn: 'Duqarah' },
          { id: 'qir-13', nameAr: 'زحر', nameEn: 'Zahar' },
          { id: 'qir-14', nameAr: 'كفر عان', nameEn: 'Kufr An' },
          { id: 'qir-15', nameAr: 'سمر', nameEn: 'Samar' },
          { id: 'qir-16', nameAr: 'قميم', nameEn: 'Qumeim' },
          { id: 'qir-17', nameAr: 'ارخيم', nameEn: 'Arkheem' },
          { id: 'qir-18', nameAr: 'خرجا', nameEn: 'Khirja' },
          { id: 'qir-19', nameAr: 'عنبة', nameEn: 'Anbeh' },
          { id: 'qir-20', nameAr: 'دير السعنة', nameEn: 'Deir Al-Sa\'neh' },
          { id: 'qir-21', nameAr: 'كفر الكيفيا', nameEn: 'Kufr Al-Keifiya' },
          // === لواء بني كنانة ===
          { id: 'qir-22', nameAr: 'ارحاب', nameEn: 'Arhab' },
          { id: 'qir-23', nameAr: 'سحم الكفارات', nameEn: 'Saham Al-Kafarat' },
          { id: 'qir-24', nameAr: 'ملكا', nameEn: 'Malka' },
          { id: 'qir-25', nameAr: 'سموع', nameEn: 'Samou' },
          { id: 'qir-26', nameAr: 'حبراص', nameEn: 'Habras' },
          { id: 'qir-27', nameAr: 'خرجا', nameEn: 'Khirja' },
          { id: 'qir-28', nameAr: 'كتم', nameEn: 'Kitm' },
          { id: 'qir-29', nameAr: 'علعال', nameEn: 'Al-Alal' },
          { id: 'qir-30', nameAr: 'سال', nameEn: 'Sal' },
          { id: 'qir-31', nameAr: 'قم', nameEn: 'Qum' },
          { id: 'qir-32', nameAr: 'جمحا', nameEn: 'Jimha' },
          { id: 'qir-33', nameAr: 'يبلا', nameEn: 'Yabla' },
          { id: 'qir-34', nameAr: 'عقربا', nameEn: 'Aqraba' },
          { id: 'qir-35', nameAr: 'الشجرة', nameEn: 'Al-Shajara' },
          { id: 'qir-36', nameAr: 'المخيبة التحتا', nameEn: 'Al-Mukhaybeh Al-Tahta' },
          { id: 'qir-37', nameAr: 'المخيبة الفوقا', nameEn: 'Al-Mukhaybeh Al-Foqa' },
          { id: 'qir-38', nameAr: 'ام قيس', nameEn: 'Um Qais' },
          { id: 'qir-39', nameAr: 'حوفا', nameEn: 'Hawfa' },
          { id: 'qir-40', nameAr: 'قويلبة', nameEn: 'Qweilbeh' },
          { id: 'qir-41', nameAr: 'خربة وهدة', nameEn: 'Khirbet Wahdeh' },
          { id: 'qir-42', nameAr: 'دير قنة', nameEn: 'Deir Qinneh' },
          // === لواء المزار الشمالي ===
          { id: 'qir-43', nameAr: 'المزار الشمالي', nameEn: 'Al-Mazar Al-Shamali' },
          { id: 'qir-44', nameAr: 'حكما', nameEn: 'Hakama' },
          { id: 'qir-45', nameAr: 'زبدة', nameEn: 'Zabda' },
          { id: 'qir-46', nameAr: 'كفر سوم', nameEn: 'Kufr Soum' },
          { id: 'qir-47', nameAr: 'كفر اسد', nameEn: 'Kufr Asad' },
          { id: 'qir-48', nameAr: 'علان', nameEn: 'Allan' },
          { id: 'qir-49', nameAr: 'جحفية', nameEn: 'Jahfiyeh' },
          { id: 'qir-50', nameAr: 'بشرى', nameEn: 'Bushra' },
          { id: 'qir-51', nameAr: 'كفر جايز', nameEn: 'Kufr Jayez' },
          { id: 'qir-52', nameAr: 'دير الليات', nameEn: 'Deir Al-Layyat' },
          { id: 'qir-53', nameAr: 'حبكا', nameEn: 'Habaka' },
          { id: 'qir-54', nameAr: 'ام قنطرة', nameEn: 'Um Qantarah' },
          { id: 'qir-55', nameAr: 'ايدون', nameEn: 'Aidoun' },
          { id: 'qir-56', nameAr: 'مندح', nameEn: 'Mandah' },
          { id: 'qir-57', nameAr: 'جمحا', nameEn: 'Jamha' },
          { id: 'qir-58', nameAr: 'صمد', nameEn: 'Samad' },
          { id: 'qir-59', nameAr: 'خرجا', nameEn: 'Kharja' },
          { id: 'qir-60', nameAr: 'دير السعنة', nameEn: 'Deir Al-Saaneh' },
          // === الطيبة ===
          { id: 'qir-61', nameAr: 'الطيبة', nameEn: 'Al-Taybeh' },
          { id: 'qir-62', nameAr: 'ام الغزلان', nameEn: 'Um Al-Ghuzlan' },
          { id: 'qir-63', nameAr: 'كفر الوسطية', nameEn: 'Kufr Al-Wastiyeh' },
          { id: 'qir-64', nameAr: 'النعيمة', nameEn: 'Al-Naymeh' },
          { id: 'qir-65', nameAr: 'زمال', nameEn: 'Zammal' },
          { id: 'qir-66', nameAr: 'كفرالنونة', nameEn: 'Kufr Al-Nunah' },
          { id: 'qir-67', nameAr: 'ام ابرة', nameEn: 'Um Ibrah' },
          { id: 'qir-68', nameAr: 'الصريح', nameEn: 'Al-Sarih' },
          { id: 'qir-69', nameAr: 'كفر رحتا', nameEn: 'Kufr Rahta' },
          { id: 'qir-70', nameAr: 'دير البرك', nameEn: 'Deir Al-Burak' },
          // === الوسطية ===
          { id: 'qir-71', nameAr: 'الوسطية', nameEn: 'Al-Wastiyyeh' },
          { id: 'qir-72', nameAr: 'حوارة', nameEn: 'Hawwarah' },
          { id: 'qir-73', nameAr: 'بيت راس', nameEn: 'Beit Ras' },
          { id: 'qir-74', nameAr: 'بيت يافا', nameEn: 'Beit Yafa' },
          { id: 'qir-75', nameAr: 'حور', nameEn: 'Hawar' },
          { id: 'qir-76', nameAr: 'دير الصمادية', nameEn: 'Deir Al-Samadiyeh' },
          { id: 'qir-77', nameAr: 'ناطفة', nameEn: 'Natfeh' },
          { id: 'qir-78', nameAr: 'زبده فركوح', nameEn: 'Zabdeh Farkoh' },
          { id: 'qir-79', nameAr: 'كفر كيفيا', nameEn: 'Kufr Keifiya' },
          { id: 'qir-80', nameAr: 'دير غزالة', nameEn: 'Deir Ghazaleh' },
          { id: 'qir-81', nameAr: 'فوعرا', nameEn: 'Foarah' },
          { id: 'qir-82', nameAr: 'سالة', nameEn: 'Saleh' },
        ],
      },
      {
        id: 'jo-18', nameAr: 'الصحراوي', nameEn: 'Desert Highway',
        areas: [
          { id: 'sh-1', nameAr: 'القطرانة', nameEn: 'Al-Qatraneh' },
          { id: 'sh-2', nameAr: 'الحسا', nameEn: 'Al-Hasa' },
          { id: 'sh-3', nameAr: 'الحسينية', nameEn: 'Al-Husayniyeh' },
          { id: 'sh-4', nameAr: 'جرف الدراويش', nameEn: 'Jurf Al-Darawish' },
          { id: 'sh-5', nameAr: 'الابيض', nameEn: 'Al-Abyad' },
          { id: 'sh-6', nameAr: 'فجيج', nameEn: 'Fujaij' },
          { id: 'sh-7', nameAr: 'عنيزة', nameEn: 'Unayzah' },
          { id: 'sh-8', nameAr: 'سلطاني', nameEn: 'Sultani' },
          { id: 'sh-9', nameAr: 'المنزل', nameEn: 'Al-Manzil' },
          { id: 'sh-10', nameAr: 'ام الرصاص', nameEn: 'Um Al-Rasas' },
          { id: 'sh-11', nameAr: 'زحوم', nameEn: 'Zahoom' },
          { id: 'sh-12', nameAr: 'الطيبة', nameEn: 'Al-Taybeh' },
          { id: 'sh-13', nameAr: 'اذرح', nameEn: 'Udhruh' },
          { id: 'sh-14', nameAr: 'نجل', nameEn: 'Najl' },
          { id: 'sh-15', nameAr: 'الثنية', nameEn: 'Al-Thaniyeh' },
          { id: 'sh-16', nameAr: 'بئر الدباغات', nameEn: 'Bir Al-Dabbaghat' },
          { id: 'sh-17', nameAr: 'المريغة', nameEn: 'Al-Muraygha' },
          { id: 'sh-18', nameAr: 'العدسية', nameEn: 'Al-Adasiyeh' },
          { id: 'sh-19', nameAr: 'بسطة', nameEn: 'Basta' },
          { id: 'sh-20', nameAr: 'ابو ترابة', nameEn: 'Abu Turabah' },
          { id: 'sh-21', nameAr: 'الشهابية', nameEn: 'Al-Shahabiyeh' },
          { id: 'sh-22', nameAr: 'المحمدية', nameEn: 'Al-Muhammadiyeh' },
        ],
      },
    ],
  },
];

const saveCountries = (countries: Country[]) => {
  localStorage.setItem(COUNTRIES_KEY, JSON.stringify(countries));
  window.dispatchEvent(new Event('countries-updated'));
  // Sync to DB in background
  import('@/lib/settingsSync').then(({ saveSetting, SETTINGS_KEYS }) => {
    saveSetting(SETTINGS_KEYS.COUNTRIES, countries).catch(() => {});
  }).catch(() => {});
};

export const getCountries = (): Country[] => {
  const version = localStorage.getItem(COUNTRIES_VERSION_KEY);
  if (version !== COUNTRIES_VERSION) {
    localStorage.setItem(COUNTRIES_VERSION_KEY, COUNTRIES_VERSION);
    saveCountries(defaultCountries);
    return defaultCountries;
  }
  const data = localStorage.getItem(COUNTRIES_KEY);
  if (!data) {
    saveCountries(defaultCountries);
    return defaultCountries;
  }
  return JSON.parse(data);
};

export const toggleCountry = (id: string, enabled: boolean): void => {
  const countries = getCountries();
  const idx = countries.findIndex(c => c.id === id);
  if (idx === -1) return;
  countries[idx].enabled = enabled;
  saveCountries(countries);
};

export const addCityToCountry = (countryId: string, city: Omit<City, 'id'>): City | null => {
  const countries = getCountries();
  const idx = countries.findIndex(c => c.id === countryId);
  if (idx === -1) return null;
  const newCity: City = { ...city, id: generateId(), areas: [] };
  countries[idx].cities.push(newCity);
  saveCountries(countries);
  return newCity;
};

export const removeCityFromCountry = (countryId: string, cityId: string): void => {
  const countries = getCountries();
  const idx = countries.findIndex(c => c.id === countryId);
  if (idx === -1) return;
  countries[idx].cities = countries[idx].cities.filter(c => c.id !== cityId);
  saveCountries(countries);
};

export const addCountry = (data: { nameAr: string; nameEn: string }): Country => {
  const countries = getCountries();
  const newCountry: Country = { id: generateId(), ...data, cities: [], enabled: true };
  countries.push(newCountry);
  saveCountries(countries);
  return newCountry;
};

export const deleteCountry = (id: string): void => {
  const countries = getCountries();
  saveCountries(countries.filter(c => c.id !== id));
};

/** Returns all cities from enabled countries */
export const getEnabledCities = (): { cityNameAr: string; cityNameEn: string; deliveryFee?: number }[] => {
  const countries = getCountries();
  const cities: { cityNameAr: string; cityNameEn: string; deliveryFee?: number }[] = [];
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      cities.push({ cityNameAr: city.nameAr, cityNameEn: city.nameEn, deliveryFee: city.deliveryFee });
    }
  }
  return cities;
};

/** Update delivery fee for a specific city */
export const updateCityDeliveryFee = (countryId: string, cityId: string, fee: number): void => {
  const countries = getCountries();
  const country = countries.find(c => c.id === countryId);
  if (!country) return;
  const city = country.cities.find(c => c.id === cityId);
  if (!city) return;
  city.deliveryFee = fee;
  saveCountries(countries);
};

export interface AreaCorrectionResult {
  corrected: boolean;
  correctedCity?: string;
  originalCity?: string;
  area?: string;
  otherCities?: string[];
}

/** Auto-save a new area to a city by city name (skips if already exists).
 *  Checks cross-city: if the area belongs to another city, returns a correction instead of saving. */
export const autoSaveAreaToCity = (cityName: string, areaName: string): AreaCorrectionResult | null => {
  if (!cityName.trim() || !areaName.trim()) return null;
  const countries = getCountries();
  const areaNorm = areaName.trim().toLowerCase();

  // 1. Find all cities that already have this area (exact match first, then partial)
  const citiesWithArea: string[] = [];
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      if (!city.areas) continue;
      const has = city.areas.some(a => {
        const aNameAr = a.nameAr.trim().toLowerCase();
        const aNameEn = a.nameEn.trim().toLowerCase();
        // Exact match
        if (aNameAr === areaNorm || aNameEn === areaNorm) return true;
        // Partial/substring match (min 3 chars to avoid false positives)
        if (areaNorm.length >= 3) {
          if (aNameAr.includes(areaNorm) || areaNorm.includes(aNameAr) && aNameAr.length >= 3) return true;
          if (aNameEn.includes(areaNorm) || areaNorm.includes(aNameEn) && aNameEn.length >= 3) return true;
        }
        return false;
      });
      if (has) {
        if (!citiesWithArea.includes(city.nameAr)) {
          citiesWithArea.push(city.nameAr);
        }
      }
    }
  }

  // 2. Check if the input city matches any of those cities
  const inputCityNorm = cityName.trim().toLowerCase();
  const inputCityMatches = citiesWithArea.some(c => c.toLowerCase() === inputCityNorm);

  if (citiesWithArea.length > 0) {
    if (inputCityMatches) {
      // Area already exists in the input city — no correction, no save needed
      const otherCities = citiesWithArea.filter(c => c.toLowerCase() !== inputCityNorm);
      if (otherCities.length > 0) {
        return { corrected: false, otherCities };
      }
      return null;
    }
    // Area belongs to other city(ies) — correct
    const correctedCity = citiesWithArea[0];
    const otherCities = citiesWithArea.slice(1);
    return {
      corrected: true,
      correctedCity,
      originalCity: cityName,
      area: areaName,
      otherCities: otherCities.length > 0 ? otherCities : undefined,
    };
  }

  // 3. Area not found in any city — save it to the input city
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      const match = city.nameAr === cityName || city.nameEn === cityName ||
        city.nameAr.trim() === cityName.trim() || city.nameEn.trim() === cityName.trim();
      if (match) {
        if (!city.areas) city.areas = [];
        const already = city.areas.some(a =>
          a.nameAr.trim().toLowerCase() === areaNorm ||
          a.nameEn.trim().toLowerCase() === areaNorm
        );
        if (already) return null;
        city.areas.push({ id: generateId(), nameAr: areaName, nameEn: areaName });
        saveCountries(countries);
        return null;
      }
    }
  }
  return null;
};

/** Add area to a city */
export const addAreaToCity = (countryId: string, cityId: string, area: Omit<Area, 'id'>): Area | null => {
  const countries = getCountries();
  const country = countries.find(c => c.id === countryId);
  if (!country) return null;
  const city = country.cities.find(c => c.id === cityId);
  if (!city) return null;
  if (!city.areas) city.areas = [];
  const newArea: Area = { ...area, id: generateId() };
  city.areas.push(newArea);
  saveCountries(countries);
  return newArea;
};

/** Remove area from a city by name (for cross-city conflict resolution) */
export const removeAreaFromCityByName = (cityName: string, areaName: string): boolean => {
  const countries = getCountries();
  const areaNorm = areaName.trim().toLowerCase();
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      const match = city.nameAr === cityName || city.nameEn === cityName ||
        city.nameAr.trim() === cityName.trim() || city.nameEn.trim() === cityName.trim();
      if (match && city.areas) {
        const idx = city.areas.findIndex(a => {
          const aAr = a.nameAr.trim().toLowerCase();
          const aEn = a.nameEn.trim().toLowerCase();
          return aAr === areaNorm || aEn === areaNorm ||
            areaNorm.includes(aAr) || aAr.includes(areaNorm) ||
            areaNorm.includes(aEn) || aEn.includes(areaNorm);
        });
        if (idx >= 0) {
          city.areas.splice(idx, 1);
          saveCountries(countries);
          return true;
        }
      }
    }
  }
  return false;
};

/** Remove area from a city */
export const removeAreaFromCity = (countryId: string, cityId: string, areaId: string): void => {
  const countries = getCountries();
  const country = countries.find(c => c.id === countryId);
  if (!country) return;
  const city = country.cities.find(c => c.id === cityId);
  if (!city || !city.areas) return;
  city.areas = city.areas.filter(a => a.id !== areaId);
  saveCountries(countries);
};

/** Edit area in a city */
export const editAreaInCity = (countryId: string, cityId: string, areaId: string, updates: { nameAr: string; nameEn: string }): void => {
  const countries = getCountries();
  const country = countries.find(c => c.id === countryId);
  if (!country) return;
  const city = country.cities.find(c => c.id === cityId);
  if (!city || !city.areas) return;
  const area = city.areas.find(a => a.id === areaId);
  if (!area) return;
  area.nameAr = updates.nameAr;
  area.nameEn = updates.nameEn;
  saveCountries(countries);
};

/** Move areas from one city to another */
export const moveAreasToCity = (fromCountryId: string, fromCityId: string, toCountryId: string, toCityId: string, areaIds: string[]): void => {
  const countries = getCountries();
  const fromCountry = countries.find(c => c.id === fromCountryId);
  const toCountry = countries.find(c => c.id === toCountryId);
  if (!fromCountry || !toCountry) return;
  const fromCity = fromCountry.cities.find(c => c.id === fromCityId);
  const toCity = toCountry.cities.find(c => c.id === toCityId);
  if (!fromCity || !toCity || !fromCity.areas) return;
  if (!toCity.areas) toCity.areas = [];
  const areasToMove = fromCity.areas.filter(a => areaIds.includes(a.id));
  fromCity.areas = fromCity.areas.filter(a => !areaIds.includes(a.id));
  toCity.areas.push(...areasToMove);
  saveCountries(countries);
};

/**
 * Resolve a city name that might actually be an area/district name.
 * Returns the parent city info if found, or null if the name is already a valid city or unknown.
 */
export const resolveCityFromArea = (name: string): { cityNameAr: string; cityNameEn: string; areaName: string } | null => {
  if (!name?.trim()) return null;
  const trimmed = name.trim();
  const countries = getCountries();
  
  // First check if it's already a known city — no correction needed
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      if (city.nameAr === trimmed || city.nameEn === trimmed) return null;
    }
  }
  
  // Search in areas of all cities
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      if (!city.areas) continue;
      for (const area of city.areas) {
        if (area.nameAr === trimmed || area.nameEn === trimmed) {
          return { cityNameAr: city.nameAr, cityNameEn: city.nameEn, areaName: trimmed };
        }
      }
    }
  }
  return null;
};

/**
 * Resolve a city from address text by searching for known area names within the address.
 * Tokenizes the address and checks all single words, 2-word, and 3-word combinations
 * against all stored areas. Prioritizes longer matches.
 * Returns the parent city info + matched area, or null if no area is found.
 */
export const resolveCityFromAddress = (address: string): { cityNameAr: string; cityNameEn: string; matchedArea: string } | null => {
  if (!address?.trim()) return null;
  const countries = getCountries();
  
  // Build a map of area names → parent city for fast lookup
  // Also keep a list of all area names for partial matching
  const areaMap = new Map<string, { cityNameAr: string; cityNameEn: string }>();
  const allAreas: { name: string; cityNameAr: string; cityNameEn: string }[] = [];
  for (const country of countries) {
    if (!country.enabled) continue;
    for (const city of country.cities) {
      if (!city.areas) continue;
      for (const area of city.areas) {
        areaMap.set(area.nameAr, { cityNameAr: city.nameAr, cityNameEn: city.nameEn });
        areaMap.set(area.nameEn.toLowerCase(), { cityNameAr: city.nameAr, cityNameEn: city.nameEn });
        allAreas.push({ name: area.nameAr, cityNameAr: city.nameAr, cityNameEn: city.nameEn });
        allAreas.push({ name: area.nameEn.toLowerCase(), cityNameAr: city.nameAr, cityNameEn: city.nameEn });
      }
    }
  }
  
  // Tokenize the address
  const tokens = address.trim().split(/[\s,\-\/]+/).filter(t => t.length > 0);
  if (tokens.length === 0) return null;
  
  // Phase 1: Exact match — try combinations from longest (3 words) to shortest (1 word)
  let bestMatch: { cityNameAr: string; cityNameEn: string; matchedArea: string } | null = null;
  let bestLen = 0;
  
  for (let windowSize = Math.min(3, tokens.length); windowSize >= 1; windowSize--) {
    for (let i = 0; i <= tokens.length - windowSize; i++) {
      const phrase = tokens.slice(i, i + windowSize).join(' ');
      const cityInfo = areaMap.get(phrase) || areaMap.get(phrase.toLowerCase());
      if (cityInfo && phrase.length > bestLen) {
        bestMatch = { ...cityInfo, matchedArea: phrase };
        bestLen = phrase.length;
      }
    }
    if (bestMatch) break;
  }
  
  if (bestMatch) return bestMatch;
  
  // Phase 2: Partial/substring match — check if any stored area name contains the input or vice versa
  const addressNorm = address.trim().toLowerCase();
  let partialMatch: { cityNameAr: string; cityNameEn: string; matchedArea: string } | null = null;
  let partialLen = 0;
  
  for (const area of allAreas) {
    const areaNorm = area.name.toLowerCase();
    if (areaNorm.length < 3) continue; // skip very short area names
    
    // Check if input address contains the area name or area name contains the input
    const inputContainsArea = addressNorm.includes(areaNorm) && areaNorm.length >= 3;
    const areaContainsInput = areaNorm.includes(addressNorm) && addressNorm.length >= 3;
    
    if ((inputContainsArea || areaContainsInput) && areaNorm.length > partialLen) {
      partialMatch = { cityNameAr: area.cityNameAr, cityNameEn: area.cityNameEn, matchedArea: area.name };
      partialLen = areaNorm.length;
    }
  }
  
  if (partialMatch) return partialMatch;
  
  // Phase 3: No match found — return Amman as default with special marker
  return { cityNameAr: 'عمان', cityNameEn: 'Amman', matchedArea: '__default__' };
};
